var _style, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNoGraphInDashboard(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "animated",
    id: "freepik_stories-visual-data",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n    @keyframes fadeIn{0%{opacity:0}to{opacity:1}}@keyframes slideLeft{0%{opacity:0;transform:translateX(-30px)}to{opacity:1;transform:translateX(0)}}@keyframes slideRight{0%{opacity:0;transform:translateX(30px)}to{opacity:1;transform:translateX(0)}}@keyframes floating{0%,to{opacity:1;transform:translateY(0)}50%{transform:translateY(-10px)}}svg#freepik_stories-visual-data:not(.animated) .animable{opacity:0}svg#freepik_stories-visual-data.animated #freepik--screen-1--inject-4{animation:1s 1 forwards cubic-bezier(.36,-.01,.5,1.38) slideRight,1.5s Infinite linear floating;animation-delay:0s,1s}svg#freepik_stories-visual-data.animated #freepik--screen-2--inject-4{animation:1s 1 forwards cubic-bezier(.36,-.01,.5,1.38) slideLeft,1.5s Infinite linear floating;animation-delay:0s,1s}svg#freepik_stories-visual-data.animated #freepik--speech-bubbles--inject-4{animation:1s 1 forwards cubic-bezier(.36,-.01,.5,1.38) fadeIn;animation-delay:0s}\n  ")), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-4",
    className: "animable",
    style: {
      transformOrigin: "252.63px 356.9px",
      animation: "1s 1 forwards cubic-bezier(.36,-.01,.5,1.38) fadeIn",
      animationDelay: "0s"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--floor--inject-4",
    className: "animable",
    style: {
      transformOrigin: "252.63px 356.9px"
    }
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 252.63,
    cy: 356.9,
    rx: 240.08,
    ry: 122.65,
    style: {
      fill: "#f5f5f5",
      transformOrigin: "252.63px 356.9px"
    },
    id: "elzzpl20106m8",
    className: "animable"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shadow--inject-4",
    className: "animable",
    style: {
      transformOrigin: "250.176px 367.098px",
      animation: "1s 1 forwards cubic-bezier(.36,-.01,.5,1.38) fadeIn",
      animationDelay: "0s"
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "freepik--shadow--inject-4",
    d: "M96.63 340.16c16.45 9.27 16.62 24.58.36 34.21s-42.78 9.9-59.24.64-16.63-24.59-.37-34.21 42.79-9.91 59.25-.64Z",
    style: {
      fill: "#e0e0e0",
      transformOrigin: "67.1856px 357.585px"
    },
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M461.65 356c17.72 10 17.9 26.47.4 36.83s-46.05 10.66-63.77.69-17.9-26.47-.4-36.83 46.06-10.69 63.77-.69Z",
    style: {
      fill: "#e0e0e0",
      transformOrigin: "429.965px 374.754px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Gears--inject-4",
    className: "animable",
    style: {
      transformOrigin: "352.89px 70.3783px",
      animation: "1s 1 forwards cubic-bezier(.36,-.01,.5,1.38) fadeIn",
      animationDelay: "0s"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--gears--inject-4",
    className: "animable",
    style: {
      transformOrigin: "352.89px 70.3783px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M334.19 90.89h-.22l-2.21-.34a1.27 1.27 0 0 1-.88-.56 1.31 1.31 0 0 1-.13-1l1.25-4.14a1 1 0 0 0-.3-.86 8.94 8.94 0 0 1-.66-.71.35.35 0 0 0-.5-.1l-2.77 2.1a1.06 1.06 0 0 1-1 .19 1.08 1.08 0 0 1-.66-.79l-.75-3.13a2.25 2.25 0 0 1 .51-1.91l2.73-2.86a2.19 2.19 0 0 0 .48-1.17 19.12 19.12 0 0 1 .23-2.2.57.57 0 0 0-.34-.59l-1.75-.61a1.37 1.37 0 0 1-.77-.69 1.34 1.34 0 0 1 0-1l1.68-4.57a1.83 1.83 0 0 1 1.62-1.14h2.11a1.18 1.18 0 0 0 .87-.52c.45-.75.92-1.48 1.42-2.15a2.06 2.06 0 0 0 .32-1.19l-.41-3.1a2.33 2.33 0 0 1 .69-1.86l3.11-2.8a1 1 0 0 1 1.73.43l.9 2.4a.28.28 0 0 0 .14.16.32.32 0 0 0 .25 0 10.52 10.52 0 0 1 1.38-.56 1.69 1.69 0 0 0 .88-.75l1.8-4.05a1.67 1.67 0 0 1 1.72-.94l2.22.34a1.23 1.23 0 0 1 .87.56 1.26 1.26 0 0 1 .14 1l-1.22 4.1a1 1 0 0 0 .29.86 5.67 5.67 0 0 1 .67.71.36.36 0 0 0 .5.1l2.77-2.1a1 1 0 0 1 1.66.59l.76 3.13a2.24 2.24 0 0 1-.52 1.92l-2.8 2.78a2.15 2.15 0 0 0-.48 1.17 18.73 18.73 0 0 1-.23 2.19.56.56 0 0 0 .34.59l1.75.62a1.33 1.33 0 0 1 .81 1.73l-1.69 4.56a1.83 1.83 0 0 1-1.61 1.15h-2.11a1.21 1.21 0 0 0-.87.53c-.45.75-.92 1.47-1.42 2.15a2 2 0 0 0-.32 1.19l.4 3.1a2.31 2.31 0 0 1-.68 1.86l-3.11 2.79a1 1 0 0 1-1.73-.42l-.9-2.41a.26.26 0 0 0-.14-.15.32.32 0 0 0-.25 0 12.11 12.11 0 0 1-1.38.56 1.7 1.7 0 0 0-.89.75l-1.79 4.05a1.69 1.69 0 0 1-1.51 1.01Zm-3.49-8.76a1.38 1.38 0 0 1 1.08.53 5.36 5.36 0 0 0 .56.6 1.94 1.94 0 0 1 .57 1.86l-1.21 4.1a.24.24 0 0 0 0 .22.23.23 0 0 0 .19.11l2.21.35a.7.7 0 0 0 .68-.37l1.8-4a2.66 2.66 0 0 1 1.47-1.29 8.32 8.32 0 0 0 1.26-.51 1.3 1.3 0 0 1 1-.05 1.26 1.26 0 0 1 .7.73l.9 2.4c0 .07 0 .1.06.1a.22.22 0 0 0 .09-.06l3.17-2.85a1.37 1.37 0 0 0 .37-1l-.4-3.11a2.93 2.93 0 0 1 .5-1.89c.47-.65.93-1.35 1.36-2.07a2.16 2.16 0 0 1 1.7-1h2.11a.84.84 0 0 0 .71-.5l1.69-4.57a.36.36 0 0 0 0-.27.34.34 0 0 0-.21-.18l-1.75-.62a1.54 1.54 0 0 1-1-1.67c.11-.71.18-1.41.22-2.09a3.13 3.13 0 0 1 .75-1.8l2.72-2.9a1.28 1.28 0 0 0 .27-1l-.75-3.13a.41.41 0 0 0 0-.09h-.08l-2.77 2.1a1.32 1.32 0 0 1-1.86-.27 6.4 6.4 0 0 0-.56-.6 1.93 1.93 0 0 1-.57-1.86l1.21-4.1a.24.24 0 0 0 0-.22.25.25 0 0 0-.19-.11l-2.22-.34a.7.7 0 0 0-.67.37L344 55.17a2.64 2.64 0 0 1-1.47 1.28 11.08 11.08 0 0 0-1.26.51 1.26 1.26 0 0 1-1 0 1.21 1.21 0 0 1-.7-.72l-.9-2.41c0-.06 0-.09-.06-.09a.22.22 0 0 0-.09.06l-3.11 2.79a1.37 1.37 0 0 0-.37 1l.4 3.1a3 3 0 0 1-.5 1.9c-.47.65-.93 1.35-1.36 2.07a2.18 2.18 0 0 1-1.7 1h-2.12a.86.86 0 0 0-.7.5l-1.69 4.57a.39.39 0 0 0 0 .28.37.37 0 0 0 .21.18l1.75.61a1.57 1.57 0 0 1 1 1.68 19.27 19.27 0 0 0-.22 2.09 3.13 3.13 0 0 1-.75 1.8l-2.72 2.86a1.21 1.21 0 0 0-.27 1l.75 3.13a.19.19 0 0 0 0 .09l.08-.05 2.77-2.1a1.28 1.28 0 0 1 .73-.17Zm7-2.68a4.09 4.09 0 0 1-1.17-.17 4.32 4.32 0 0 1-2.78-3.36c-.93-3.84 1.15-9.51 4.63-12.64 1.94-1.74 4-2.44 5.72-1.91a4.32 4.32 0 0 1 2.79 3.36c.92 3.84-1.15 9.5-4.63 12.63a7.09 7.09 0 0 1-4.6 2.09Zm5.23-17.27A6.14 6.14 0 0 0 339 64c-3.24 2.91-5.18 8.14-4.34 11.67a3.35 3.35 0 0 0 2.12 2.65c1.37.42 3.1-.2 4.78-1.71 3.24-2.91 5.18-8.15 4.33-11.67a3.32 3.32 0 0 0-2.12-2.65 2.84 2.84 0 0 0-.88-.11Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "340.34px 70.3783px"
    },
    id: "el524aespebwi",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.49 79.32h-.15l-1.46-.22a.91.91 0 0 1-.63-.41.89.89 0 0 1-.09-.73l.8-2.7a.56.56 0 0 0-.17-.48 4 4 0 0 1-.45-.47.17.17 0 0 0-.22-.06l-1.82 1.38a.74.74 0 0 1-1.22-.43l-.49-2.06a1.55 1.55 0 0 1 .41-1.34l1.79-1.88a1.36 1.36 0 0 0 .29-.72 12.75 12.75 0 0 1 .15-1.45.29.29 0 0 0-.17-.3l-1.15-.4a1 1 0 0 1-.55-.5 1 1 0 0 1 0-.74l1.11-3a1.28 1.28 0 0 1 1.13-.8h1.38a.74.74 0 0 0 .51-.31c.29-.49.61-1 .94-1.42a1.2 1.2 0 0 0 .19-.73l-.26-2a1.58 1.58 0 0 1 .48-1.28l2-1.84a.76.76 0 0 1 1.26.31l.59 1.58c.08.07.11.06.15.05a7.79 7.79 0 0 1 .92-.38 1.06 1.06 0 0 0 .53-.44l1.18-2.67a1.18 1.18 0 0 1 1.22-.66l1.45.22a.94.94 0 0 1 .63.41.89.89 0 0 1 .09.73l-.79 2.7a.56.56 0 0 0 .17.48 5 5 0 0 1 .44.47.16.16 0 0 0 .22.06l1.82-1.38a.78.78 0 0 1 .74-.14.76.76 0 0 1 .48.57l.49 2.06a1.54 1.54 0 0 1-.35 1.33l-1.79 1.88a1.3 1.3 0 0 0-.3.72 12.52 12.52 0 0 1-.15 1.45.29.29 0 0 0 .17.3l1.15.4a1 1 0 0 1 .55.5 1 1 0 0 1 0 .74l-1.11 3a1.28 1.28 0 0 1-1.13.8h-1.38a.72.72 0 0 0-.51.3c-.29.49-.61 1-.93 1.42a1.21 1.21 0 0 0-.2.73l.26 2a1.64 1.64 0 0 1-.47 1.29l-2 1.83a.8.8 0 0 1-.72.2.78.78 0 0 1-.55-.51l-.59-1.58c-.08-.07-.11-.06-.15 0a7 7 0 0 1-.91.38 1 1 0 0 0-.54.44l-1.18 2.67a1.18 1.18 0 0 1-1.11.63Zm-2.29-5.91a1 1 0 0 1 .77.38 2.69 2.69 0 0 0 .36.39 1.35 1.35 0 0 1 .39 1.3l-.79 2.69.07.12 1.46.23a.37.37 0 0 0 .36-.2l1.18-2.66a1.78 1.78 0 0 1 1-.88 7.67 7.67 0 0 0 .81-.33.9.9 0 0 1 .75 0 .88.88 0 0 1 .5.52l.59 1.58 2-1.84a.85.85 0 0 0 .22-.59l-.26-2a2 2 0 0 1 .34-1.3c.31-.43.61-.89.89-1.36a1.49 1.49 0 0 1 1.18-.69h1.39a.48.48 0 0 0 .39-.28l1.11-3a.16.16 0 0 0 0-.12.18.18 0 0 0-.09-.08l-1.15-.4a1.11 1.11 0 0 1-.7-1.19 13.07 13.07 0 0 0 .14-1.36 2.13 2.13 0 0 1 .52-1.24l1.79-1.87a.79.79 0 0 0 .16-.59l-.5-2.06-1.78 1.4a1 1 0 0 1-1.32-.19 4.59 4.59 0 0 0-.37-.39 1.35 1.35 0 0 1-.39-1.3l.8-2.69v-.52l-.06.4-1.44-.29a.37.37 0 0 0-.36.2L373 55.81a1.84 1.84 0 0 1-1 .89 4.93 4.93 0 0 0-.81.33.93.93 0 0 1-.75 0 .88.88 0 0 1-.5-.52l-.63-1.51-2 1.84a.85.85 0 0 0-.22.59l.27 2a2 2 0 0 1-.35 1.3c-.31.43-.61.89-.89 1.36a1.53 1.53 0 0 1-1.18.7h-1.39a.48.48 0 0 0-.39.28l-1.11 3a.16.16 0 0 0 0 .12.18.18 0 0 0 .09.08l1.15.4a1.11 1.11 0 0 1 .7 1.19 13.07 13.07 0 0 0-.14 1.36 2.16 2.16 0 0 1-.51 1.24l-1.8 1.87a.8.8 0 0 0-.16.6l.5 2 1.78-1.4a1 1 0 0 1 .54-.12Zm4.57-1.6a2.61 2.61 0 0 1-.79-.12 2.9 2.9 0 0 1-1.88-2.26c-.61-2.55.76-6.31 3.07-8.38a4.11 4.11 0 0 1 3.83-1.27 2.9 2.9 0 0 1 1.88 2.22c.62 2.55-.76 6.31-3.06 8.38a4.75 4.75 0 0 1-3.05 1.43Zm3.44-11.35a3.94 3.94 0 0 0-2.51 1.19c-2.11 1.89-3.38 5.3-2.82 7.59a2.12 2.12 0 0 0 1.34 1.69 3.38 3.38 0 0 0 3.06-1.11c2.11-1.89 3.38-5.3 2.83-7.59a2.14 2.14 0 0 0-1.35-1.69 2 2 0 0 0-.55-.08Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "370.515px 65.7657px"
    },
    id: "elhgzdiyypnf5",
    className: "animable"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-2--inject-4",
    className: "animable",
    style: {
      transformOrigin: "58.3204px 255.17px",
      animation: "1s 1 forwards cubic-bezier(.36,-.01,.5,1.38) slideLeft",
      animationDelay: "0s"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-4",
    className: "animable",
    style: {
      transformOrigin: "58.3204px 255.17px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M98.32 353.48a2.44 2.44 0 0 1-.54 2.66 13.38 13.38 0 0 1-9.11 1.86c-4.52-.54-7-1.81-8.77-3.19s-4.35-3.33-6.39-3.74a13 13 0 0 1-4.57-1.7c-.61-.54-.53-2.92-.53-2.92Z",
    style: {
      fill: "#263238",
      transformOrigin: "83.4547px 352.304px"
    },
    id: "elcjz1gtpdkke",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.22 337.33a.72.72 0 0 0-.69.55c-.14.66-.29 2.56-.59 3.64a17.68 17.68 0 0 0-.44 5.78c.25 1.22 3.34 2.07 5.32 2.76a25.35 25.35 0 0 1 6.41 3.69 19.28 19.28 0 0 0 9.54 3.25c3.49 0 7.41-1.06 8.31-2.53 1.12-1.82.24-2.88-4.92-5.06-1-.42-4.42-2.27-5.59-2.94-3.17-1.82-6.31-4.35-7.77-7.57a1.79 1.79 0 0 0-.74-1 1.81 1.81 0 0 0-1-.09 8.79 8.79 0 0 0-2.48.69c-.7.3-1.68.65-1.67 1.46a2.66 2.66 0 0 0 .2.82c.06.17.11.39 0 .48s-.35 0-.48-.12a13.42 13.42 0 0 1-1.4-1.52 4.86 4.86 0 0 0-.81-.76 8.7 8.7 0 0 1-.89-.53c-.37-.27-.3-.63-.31-1Z",
    style: {
      fill: "#37474f",
      transformOrigin: "83.47px 347.165px"
    },
    id: "el8ao8sy4d9sg",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.23 353.75a33.34 33.34 0 0 0-2.82-1.92s6.08 3.37 8.54 1.84a1.89 1.89 0 0 0 .79-2.56c0-.38 3.21-2.36 4.75-2.52l2 .8c5.17 2.19 5.75 3.26 4.63 5.08-.9 1.47-3.74 2.62-8.25 2.62a19.8 19.8 0 0 1-9.64-3.34Z",
    style: {
      fill: "#455a64",
      transformOrigin: "88.0043px 352.84px"
    },
    id: "elkj9269jjjj",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.65 360.74a11.93 11.93 0 0 1-1 6.43c-.91 1.73-2.9 2.43-5 2.14s-4.94-1.32-5.8-3.67A14.14 14.14 0 0 1 40 359Z",
    style: {
      fill: "#263238",
      transformOrigin: "46.3253px 364.187px"
    },
    id: "elfvw1be6wjzb",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.14 341.33c-.85.14-.69 3.9-.77 7.69-.08 4.06-1.22 5.84-1.33 9.18-.12 3.81.28 5.47 2 7.61s7.09 3.9 9.26.41c1.77-2.84 1.53-5.79.93-9.53a85.55 85.55 0 0 1-1.23-9.54c-.15-2.83-.23-5.58-1-5.82v1.36c0 .42.07 1.84-.41 1.9a5.3 5.3 0 0 1-.12-1.06 1.19 1.19 0 0 0-.34-.88 1.68 1.68 0 0 0-1-.3 25 25 0 0 0-2.59-.13c-.43 0-.86 0-1.29.07a3.87 3.87 0 0 0-1.07.24.72.72 0 0 0-.42.42 1.3 1.3 0 0 0 0 .44 2.91 2.91 0 0 1 0 .78c0 .11-.09.26-.21.24s-.16-.12-.17-.21c0-.46 0-.79-.06-1.32v-.83c0-.25-.17-.48-.18-.72Z",
    style: {
      fill: "#37474f",
      transformOrigin: "46.3468px 354.765px"
    },
    id: "els181fu0s46",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.12 357.11c0 .55-.13 4.19 1 4.74s2-2.26 2-2.26a8.94 8.94 0 0 1 6.06-.15c.13.83 1 2.79 2 2.29s1-4.66 1-4.72c.56 3.59.74 6.45-1 9.21-2.17 3.49-7.55 1.73-9.26-.41s-2.1-3.8-2-7.61c.14-.38.16-.74.2-1.09Z",
    style: {
      fill: "#455a64",
      transformOrigin: "46.2383px 362.605px"
    },
    id: "elhzdkn92mera",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.32 225.6a53.45 53.45 0 0 0-4.11 15.4C41.72 260.34 41 288.4 41 288.4c-.18 2-1.46 6.61-2.32 15.5-1 10.51 1.81 45.79 1.81 45.79s6.29 3.75 11.18-.52c0 0 5.68-48.93 7-59.38C59.8 280.68 63 261 63 261l2.47 30.16s-.35 8.2-.1 13.5c.28 6.17 3.29 36.58 3.29 36.58s8.64 2.93 12.5-1.22c0 0 .91-43.58 1-51 .26-14.55-.5-41.69-1-56.48Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "60.3388px 288.406px"
    },
    id: "elu09cj5ja87s",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.32 225.6a53.45 53.45 0 0 0-4.11 15.4C41.72 260.34 41 288.4 41 288.4c-.18 2-1.46 6.61-2.32 15.5-1 10.51 1.81 45.79 1.81 45.79s6.29 3.75 11.18-.52c0 0 5.68-48.93 7-59.38C59.8 280.68 63 261 63 261l2.47 30.16s-.35 8.2-.1 13.5c.28 6.17 3.29 36.58 3.29 36.58s8.64 2.93 12.5-1.22c0 0 .91-43.58 1-51 .26-14.55-.5-41.69-1-56.48Z",
    style: {
      opacity: 0.35,
      transformOrigin: "60.3388px 288.406px"
    },
    className: "animable",
    id: "elbtc54jv69aw"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m63 261 1.35-9.28s7.84-1.05 11.39-4.39a12.88 12.88 0 0 1-9.24 5.84l-1.38 8.39-.1 26.1Z",
    style: {
      opacity: 0.2,
      transformOrigin: "69.37px 267.495px"
    },
    className: "animable",
    id: "eljt54fiogj9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m87 228.29-5.72 6.36s-4.67-5.83-4.49-5.83 5.39-8.57 5.39-8.57Z",
    style: {
      fill: "#b16668",
      transformOrigin: "81.8925px 227.45px"
    },
    id: "elwtgsf6nekf",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.92 182.41c7.64 2.17 7.73 1.66 12.57 8.1 3.36 4.47 10.05 12.75 12 16.16 2.22 3.84 2.52 5.4.79 8.28S87 228.74 87 228.74c-2.3-1.8-4.84-3.47-6.13-6.71L87 211.79l-12.66-13.06Z",
    style: {
      fill: "#455a64",
      transformOrigin: "86.1572px 205.575px"
    },
    id: "els69m4a0b7kr",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52 150.14a3.86 3.86 0 0 0-.46.09 2.12 2.12 0 0 0-1.13-2.39 2.28 2.28 0 0 0-2.94 1.21l3.21 1.47a4.46 4.46 0 0 0-2.45 2.08c-.87 1.81.28 5.66 1.46 10.41a68.13 68.13 0 0 0 2.58 8.81c.54 1.38 1.51 1.43 1.51 1.43v-4.75l-.21-3.93s2.53-3.44 2.81-6.27c.35-3.63-.41-5.12-.41-5.12Z",
    style: {
      fill: "#263238",
      transformOrigin: "51.9711px 160.463px"
    },
    id: "elly4hami7gz",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.42 146.06a8 8 0 1 0 8 8 8 8 0 0 0-8-8Z",
    style: {
      fill: "#263238",
      transformOrigin: "69.42px 154.06px"
    },
    id: "elavxhwyk8i1",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.69 163.94c-.95.83-1.72-1.3-2.52-2.13s-3.39-2-4.68.77 1.19 6.57 3.13 7.47a3 3 0 0 0 4.13-1.55v11.87c3 5.4 8.76 4.34 11.83 5.1.56-2.19 1-3.22.73-4.44v-3.86a14.59 14.59 0 0 0 3.92.21c2.59-.41 4-2.54 4.75-5.35 1.25-4.51 1.51-12.08-.22-20.83-2.9-2.24-12.72-1.88-18.8 2 .42 7.74-1.32 9.92-2.27 10.74Z",
    style: {
      fill: "#b16668",
      transformOrigin: "61.0605px 167.644px"
    },
    id: "el268s57qtvja",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.51 162.08a1.22 1.22 0 1 1-1.21-1.21 1.21 1.21 0 0 1 1.21 1.21Z",
    style: {
      fill: "#263238",
      transformOrigin: "63.29px 162.09px"
    },
    id: "elgfmkn2i7a05",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.71 161.62a1.22 1.22 0 1 1-1.21-1.21 1.21 1.21 0 0 1 1.21 1.21Z",
    style: {
      fill: "#263238",
      transformOrigin: "72.49px 161.63px"
    },
    id: "el9e59bm1gpx8",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.29 177.17S60.51 176 58.48 175a6.64 6.64 0 0 1-2.8-2.75 9 9 0 0 0 1.6 3.25c1.48 1.89 9 3.26 9 3.26Z",
    style: {
      fill: "#9a4a4d",
      transformOrigin: "60.985px 175.505px"
    },
    id: "el1zcuqxywv4w",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.71 145a2.89 2.89 0 0 1 0-.29 1 1 0 0 0-.19-.5c-.39-.41-1.17.61-1.45.85a10.31 10.31 0 0 1-.83.65 5.54 5.54 0 0 0-.78.46 8.19 8.19 0 0 0 0-2.92c-.12-.63-.3-2.11-1.09-2.27-.47-.09-.88.3-1.23.63-3.16 3-7.3 1.59-11.11 1.71-3.19.1-7 1.4-8.48 4.5-.66 1.42-.77 2.92.53 3.9.84.63 1.66.6 2.13 1.61.12.25.85 3.27.42 3.24a3.31 3.31 0 0 0 3.55-2.43c.08-.33.26-.93.33-1.27a.71.71 0 0 1 .91-.55c1 .21 1.6.6 2.51.86a18.39 18.39 0 0 0 8 .47A9.46 9.46 0 0 0 75 151a7.61 7.61 0 0 0 1.71-6Z",
    style: {
      fill: "#263238",
      transformOrigin: "63.9305px 148.778px"
    },
    id: "elwyuol3brs0s",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m62.84 158.65-2.37 1.54a1.49 1.49 0 0 1 .43-2 1.37 1.37 0 0 1 1.94.46Z",
    style: {
      fill: "#263238",
      transformOrigin: "61.5471px 159.077px"
    },
    id: "el71ewznm2amt",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m64.58 169.6 3.92 1a2 2 0 0 1-2.43 1.51 2.11 2.11 0 0 1-1.49-2.51Z",
    style: {
      fill: "#9a4a4d",
      transformOrigin: "66.5127px 170.884px"
    },
    id: "el6wmhsyewpo",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.8 172.18a2.1 2.1 0 0 0-2.08-1.87h-.17a2.06 2.06 0 0 0 1.52 1.8 1.82 1.82 0 0 0 .73.07Z",
    style: {
      fill: "#f28f8f",
      transformOrigin: "65.675px 171.25px"
    },
    id: "elntkzopzuv08",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m74.71 159.45-2.59-1.2a1.37 1.37 0 0 1 1.85-.73 1.5 1.5 0 0 1 .74 1.93Z",
    style: {
      fill: "#263238",
      transformOrigin: "73.4725px 158.421px"
    },
    id: "elzhzb505hn5",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9a4a4d",
      transformOrigin: "69.755px 164.305px"
    },
    id: "el9uwcdohtjq",
    className: "animable",
    d: "m67.39 160.41.69 7.79 4.04-1.44-4.73-6.35z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.62 180.37a100.16 100.16 0 0 0-10.62 5.1s1.3 13.26 3.47 21.78c1.59 6.2 2.47 27.69 2.47 27.69a49.37 49.37 0 0 0 22.39 3.58 45.2 45.2 0 0 0 15.12-3.47s.5-13.51-.46-30.41c-.71-12.44-1.18-19-4.2-20.81-1.8-1.09-9.51-2.93-9.51-2.93a13.65 13.65 0 0 1-1.67 4.57c-2.74-1.37-16.99-5.1-16.99-5.1Z",
    style: {
      fill: "#37474f",
      transformOrigin: "59.7901px 209.511px"
    },
    id: "el5tz7n9232eb",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68 238.38c.64-.06 1.26-.14 1.86-.22.79-8.94 1.8-30.18-4.25-52.69-.03 0 5.06 26.53 2.39 52.91Z",
    style: {
      fill: "#263238",
      transformOrigin: "68.0345px 211.925px"
    },
    id: "elzc9cew6jja",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.58 185.47c2.29-1.51 4.16 2.31 4.55 1.72s-2-9-3.83-9.46V181a26.89 26.89 0 0 1-.72 4.47Z",
    style: {
      fill: "#455a64",
      transformOrigin: "67.8761px 182.491px"
    },
    id: "elaqkjdurrbfj",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.75 175.35v.93c.18.89 1.92 2.94 6.32 4.92s5.51 4.27 5.51 4.27-1-.59-2.77.44-3.7 3.91-4.65 3.89-3.89-3.3-6.38-5.92c-2.1-2.19-3.16-3.51-3.16-3.51s3.38-5 5.13-5.02Z",
    style: {
      fill: "#455a64",
      transformOrigin: "57.1px 182.575px"
    },
    id: "eli2ibpl8msm",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.18 240.36v29.88a.62.62 0 0 1-.24.56l-1.35.78a.38.38 0 0 1-.21.05.89.89 0 0 1-.39-.11L18.12 252a1.94 1.94 0 0 1-.87-1.52V220.6a.62.62 0 0 1 .24-.56h.06l1.27-.75a.51.51 0 0 1 .22-.06.92.92 0 0 1 .39.12l17.76 10.24 2.1 1.21s2.58 1.49 3.14 1.8l.08.05 10.78 6.22a1 1 0 0 1 .18.13 1.78 1.78 0 0 1 .44.53 1.74 1.74 0 0 1 .27.83Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "35.715px 245.43px"
    },
    id: "elwxc3vasx9t",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m53.93 239.5-1.31.76-.13-.2a2 2 0 0 0-.31-.33.68.68 0 0 0-.18-.13l-10.77-6.21c-.27-.16-2.7-1.56-3.19-1.83l-1.3-.75-18.6-10.72a.61.61 0 0 0-.57-.08l1.27-.75a.51.51 0 0 1 .22-.06.77.77 0 0 1 .39.12l17.76 10.24 2.1 1.21s2.58 1.49 3.14 1.8l.08.05 10.78 6.22a1 1 0 0 1 .18.13 1.78 1.78 0 0 1 .44.53Z",
    style: {
      fill: "#fff",
      opacity: 0.5,
      transformOrigin: "35.75px 229.73px"
    },
    className: "animable",
    id: "elsj0nchg0m28"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.26 220.59v29.85a1.94 1.94 0 0 0 .87 1.52l34 19.61a.52.52 0 0 0 .78-.45v-30a1.75 1.75 0 0 0-.26-.86 1.83 1.83 0 0 0-.61-.65l-10.78-6.23-3.26-1.82-19.86-11.47a.65.65 0 0 0-.57-.09.64.64 0 0 0-.31.59Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "35.0843px 245.805px"
    },
    id: "elbmp3b6id4y7",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m52.62 240.26-.13-.2a1.43 1.43 0 0 1 .13.2Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "52.555px 240.16px"
    },
    id: "el7oqruzft4ai",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m52.55 271.6 1.45-.8a.66.66 0 0 0 .23-.56v-29.88a1.79 1.79 0 0 0-.26-.87l-1.31.77a1.75 1.75 0 0 1 .26.86v30a.52.52 0 0 1-.37.48Z",
    style: {
      opacity: 0.2,
      transformOrigin: "53.3912px 255.545px"
    },
    className: "animable",
    id: "elwv3qhj8esf"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.8 222.78c7.26-29.67 11-38.77 19.81-38.66 2.57 3.08-.14 12.65-1.84 17.3 0 0-7.8 19.05-9.25 25.86-1.27 6-2.71 13.49-2.62 18.63a3.72 3.72 0 0 0 1 2.44c1.65 1.79 1.66 3.24 2.73 5.22.84 1.56 1.76 2.14 1.5 2.49a2 2 0 0 1-2.72.2 9.92 9.92 0 0 1-2.06-2A23 23 0 0 0 34 261.1l1.85 1.06s-.57 1.92-5 .64c-5-1.44-6.84-2.07-7.37-10.6a66.49 66.49 0 0 1-.09-9.44c.7-8.1 1.24-15.21 2.41-19.98Z",
    style: {
      fill: "#b16668",
      transformOrigin: "34.9658px 223.68px"
    },
    id: "el6jjkotwqxs9",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.83 181.6s-8.89 2.06-11 5.32c-2.46 3.77-3.4 8.63-7.54 23.35a127.92 127.92 0 0 0-4.71 33.91s5.18 2.42 10-.35c0 0 2.12-12.8 4-19.61s7.9-21.57 7.9-21.57 4.71-10.81 1.35-21.05Z",
    style: {
      fill: "#455a64",
      transformOrigin: "34.8095px 213.379px"
    },
    id: "el7f7xzt337i",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.8 265c.41.25.59-.51.68-1.64v-2.07s1.58 1.42 2-3.38c.43-5.28-1.93-6.25-1.93-6.25v-2.61c0-1.73-.37-2.16-.77-2.46l-.6-.3v18.34s.22.1.62.37Z",
    style: {
      fill: "#37474f",
      transformOrigin: "55.8562px 255.669px"
    },
    id: "eli0rkfu7s87",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.87 262.37c0-1.57-.15-2.51-1.16-3.12s-1.65-.95-1.65-.95l-.3-9.73s1.67 1.12 2.24 1.43.9-1.65.87-2.24l1.36.63.16 15Z",
    style: {
      fill: "#37474f",
      transformOrigin: "52.075px 255.575px"
    },
    id: "elnsmekm0rrb",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m49.58 261.43 1.19.71c.66.4.95-1.62.65-4.51l.28-6.42c-.3-2.89-.34-5.53-1-5.93l-1.19-.71Z",
    style: {
      fill: "#37474f",
      transformOrigin: "50.605px 253.38px"
    },
    id: "elpvyll551p29",
    className: "animable"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--screen-1--inject-4",
    className: "animable",
    style: {
      transformOrigin: "202.535px 202.519px"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--screen-2--inject-4",
    className: "animable",
    style: {
      transformOrigin: "202.535px 202.519px"
    }
  }, /*#__PURE__*/React.createElement("g", {
    className: "animable",
    style: {
      transformOrigin: "217.61px 202.519px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M315.5 56.19a2.79 2.79 0 0 0-1.22-2.62l-3.15-1.8a2.76 2.76 0 0 0-2.88.25L123.72 158.54a8.88 8.88 0 0 0-4 7v183.32a2.81 2.81 0 0 0 1.2 2.61l3.22 1.84A2.84 2.84 0 0 0 127 353l184.49-106.49a8.88 8.88 0 0 0 4-7Z",
    style: {
      fill: "#b0bec5",
      opacity: 0.4,
      transformOrigin: "217.61px 202.519px"
    },
    className: "animable",
    id: "el2rhimh5czpp"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.5 56.19v183.36a8.87 8.87 0 0 1-4 7L127 353c-2 1.15-3.61.45-3.94-1.52a3.65 3.65 0 0 0 .7-.33l184.49-106.49a8.88 8.88 0 0 0 4-7V54.34a4 4 0 0 0-.07-.8c1.89-.7 3.32.37 3.32 2.65Z",
    style: {
      fill: "#b0bec5",
      opacity: 0.4,
      transformOrigin: "219.28px 203.441px"
    },
    className: "animable",
    id: "eldmrrj6u725w"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m311.48 53.87-43.61 25.65-43.7 25.48-43.77 25.4-21.9 12.67-21.93 12.62-5.48 3.15-2.74 1.58c-.43.26-1 .53-1.32.78a6.67 6.67 0 0 0-1.08.92 8.28 8.28 0 0 0-2.3 5.19v31.61l-.14 50.6c-.08 33.73-.31 67.46-.52 101.19-.21-33.73-.44-67.46-.52-101.19l-.15-50.6V167.29a9.64 9.64 0 0 1 2.67-6.15 8.53 8.53 0 0 1 1.32-1.13c.52-.34.93-.55 1.4-.83l2.73-1.58 5.47-3.18 21.89-12.68 21.93-12.62 43.86-25.22 43.94-25.09Z",
    style: {
      fill: "#fff",
      transformOrigin: "216.9px 202.29px"
    },
    id: "elbecf1ffinyb",
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Chart--inject-4",
    className: "animable",
    style: {
      transformOrigin: "176.935px 272.045px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "m141.51 264.38 70.84-40.9c1.42-.81 2.56-.15 2.56 1.48v50.32a5.64 5.64 0 0 1-2.56 4.43l-70.83 40.9c-1.42.81-2.56.15-2.56-1.48v-50.32a5.66 5.66 0 0 1 2.55-4.43Z",
    style: {
      opacity: 0.15,
      transformOrigin: "176.935px 272.045px"
    },
    className: "animable",
    id: "elkm7o1hq6sq"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143 274.36a.27.27 0 0 1-.22-.13.25.25 0 0 1 .1-.35l67.67-39.07a.26.26 0 0 1 .35.09.25.25 0 0 1-.1.35l-67.67 39.07a.2.2 0 0 1-.13.04Z",
    style: {
      fill: "#fafafa",
      transformOrigin: "176.84px 254.568px"
    },
    id: "el7s6ocgrrz0a",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143 283.42a.27.27 0 0 1-.22-.13.25.25 0 0 1 .1-.35l67.67-39.07a.26.26 0 0 1 .35.09.25.25 0 0 1-.1.35l-67.67 39.07a.28.28 0 0 1-.13.04Z",
    style: {
      fill: "#fafafa",
      transformOrigin: "176.84px 263.628px"
    },
    id: "el351cyy6t3t6",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143 292.48a.27.27 0 0 1-.22-.13.25.25 0 0 1 .1-.35l67.67-39.07a.26.26 0 0 1 .35.09.25.25 0 0 1-.1.35l-67.67 39.07a.2.2 0 0 1-.13.04Z",
    style: {
      fill: "#fafafa",
      transformOrigin: "176.84px 272.688px"
    },
    id: "elrgzx0tmcub",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143 301.54a.27.27 0 0 1-.22-.13.25.25 0 0 1 .1-.35L210.55 262a.26.26 0 0 1 .35.09.25.25 0 0 1-.1.35l-67.67 39.06a.28.28 0 0 1-.13.04Z",
    style: {
      fill: "#fafafa",
      transformOrigin: "176.84px 281.753px"
    },
    id: "elmjt3c1prsx",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143 310.61a.27.27 0 0 1-.23-.14.28.28 0 0 1 .1-.37l67.67-39.1a.27.27 0 1 1 .27.47l-67.67 39.07a.23.23 0 0 1-.14.07Z",
    style: {
      fill: "#fafafa",
      transformOrigin: "176.842px 290.787px"
    },
    id: "elloatzdhzf6e",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m210.67 256.84-3.94-3.8c-1.44-1.4-3.65-.69-5.5 1.76l-.12.16c-2 2.61-4.32 3.22-5.74 1.49l-1.68-2c-1.72-2.09-4.74-.71-6.75 3.09l-1.45 2.73c-1.46 2.76-3.52 4.34-5.23 4-2-.36-4.42 1.83-5.84 5.31l-2.26 5.55c-1.27 3.12-3.38 5.25-5.28 5.34l-2 .09a5.14 5.14 0 0 0-3.47 2.19l-2.15 2.68c-2.11 2.61-4.56 2.94-5.86.78l-.09-.16c-1.9-3.17-6-.84-7.89 4.5l-2.4 6.66v13.07l67.67-39.07Z",
    style: {
      opacity: 0.3,
      transformOrigin: "176.855px 281.305px"
    },
    className: "animable",
    id: "elgx031pvovi"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143 297.44h-.08a.26.26 0 0 1-.16-.33l2.4-6.66c1.23-3.44 3.48-5.88 5.58-6.09a2.84 2.84 0 0 1 2.77 1.54l.09.16a2.4 2.4 0 0 0 1.9 1.3c1.13.07 2.4-.69 3.54-2.1l2.15-2.68a5.37 5.37 0 0 1 3.66-2.29l2-.09c1.79-.08 3.82-2.16 5-5.18l2.26-5.55c1.47-3.61 4-5.86 6.12-5.46 1.6.3 3.56-1.23 5-3.89l1.44-2.73c1.3-2.45 3.07-4 4.74-4.18a2.69 2.69 0 0 1 2.44 1.05l1.68 2a2.22 2.22 0 0 0 1.75.88h.05c1.14 0 2.42-.89 3.54-2.36l.12-.17a5.67 5.67 0 0 1 3.77-2.56 2.68 2.68 0 0 1 2.11.78l3.94 3.8a.25.25 0 1 1-.35.37l-3.95-3.8a2.12 2.12 0 0 0-1.71-.63 5.16 5.16 0 0 0-3.4 2.35l-.12.16c-1.23 1.63-2.63 2.54-3.94 2.57a2.76 2.76 0 0 1-2.21-1.06l-1.68-2a2.17 2.17 0 0 0-2-.87c-1.5.15-3.11 1.61-4.33 3.91l-1.45 2.73c-1.52 2.86-3.67 4.5-5.51 4.16s-4.2 1.82-5.55 5.14l-2.26 5.55c-1.33 3.25-3.49 5.41-5.5 5.5l-2 .09a4.91 4.91 0 0 0-3.28 2.11l-2.15 2.67c-1.27 1.57-2.69 2.39-4 2.29a2.9 2.9 0 0 1-2.3-1.54l-.09-.16a2.34 2.34 0 0 0-2.28-1.3c-1.91.19-4 2.5-5.15 5.76l-2.39 6.65a.26.26 0 0 1-.21.16Z",
    style: {
      fill: "#455a64",
      transformOrigin: "176.818px 274.741px"
    },
    id: "el4nlcbszb8be",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.31 275.2a.26.26 0 0 1-.25-.26v-1.54a.26.26 0 0 1 .25-.26.26.26 0 0 1 .26.26v1.54a.26.26 0 0 1-.26.26Zm0-3.08a.26.26 0 0 1-.25-.26v-1.54a.26.26 0 0 1 .25-.26.26.26 0 0 1 .26.26v1.54a.26.26 0 0 1-.26.26Zm0-3.08a.26.26 0 0 1-.25-.26v-1.54a.26.26 0 0 1 .25-.26.26.26 0 0 1 .26.26v1.54a.26.26 0 0 1-.26.22Zm0-3.08a.26.26 0 0 1-.25-.26v-1.54a.26.26 0 0 1 .25-.26.26.26 0 0 1 .26.26v1.54a.26.26 0 0 1-.26.3Zm0-3.08a.26.26 0 0 1-.25-.26v-1.54a.26.26 0 0 1 .25-.26.26.26 0 0 1 .26.26v1.54a.26.26 0 0 1-.26.26Zm0-3.08a.26.26 0 0 1-.25-.26V258a.26.26 0 0 1 .25-.26.26.26 0 0 1 .26.26v1.54a.26.26 0 0 1-.26.26Zm0-3.08a.26.26 0 0 1-.25-.26v-1.54a.26.26 0 0 1 .25-.26.26.26 0 0 1 .26.26v1.54a.26.26 0 0 1-.26.26Zm0-3.08a.26.26 0 0 1-.25-.26v-.95a.26.26 0 0 1 .25-.26.26.26 0 0 1 .26.26v.95a.26.26 0 0 1-.26.26Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "204.317px 263.685px"
    },
    id: "elzm3agiep6k",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.84 291.06a.26.26 0 0 1-.26-.26v-1.54a.26.26 0 0 1 .52 0v1.54a.26.26 0 0 1-.26.26Zm0-3.08a.26.26 0 0 1-.26-.26v-1.54a.26.26 0 0 1 .52 0v1.54a.26.26 0 0 1-.26.28Zm0-3.08a.26.26 0 0 1-.26-.26v-1.54a.26.26 0 0 1 .52 0v1.54a.26.26 0 0 1-.26.26Zm0-3.08a.26.26 0 0 1-.26-.26V280a.26.26 0 0 1 .52 0v1.54a.26.26 0 0 1-.26.28Zm0-3.08a.26.26 0 0 1-.26-.26v-1.54a.26.26 0 0 1 .52 0v1.54a.26.26 0 0 1-.26.26Zm0-3.08a.26.26 0 0 1-.26-.26v-1.54a.26.26 0 0 1 .52 0v1.54a.26.26 0 0 1-.26.26Zm0-3.08a.26.26 0 0 1-.26-.26v-1.54a.26.26 0 0 1 .52 0v1.54a.26.26 0 0 1-.26.26Zm0-3.08a.26.26 0 0 1-.26-.26v-1.54a.26.26 0 0 1 .52 0v1.54a.26.26 0 0 1-.26.26Zm0-3.08a.26.26 0 0 1-.26-.26v-.42a.26.26 0 0 1 .52 0v.42a.26.26 0 0 1-.26.26Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "176.84px 278.27px"
    },
    id: "elarp1toicj9h",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.1 299a.25.25 0 0 1-.25-.26v-1.54a.25.25 0 0 1 .25-.25.26.26 0 0 1 .26.25v1.54a.26.26 0 0 1-.26.26Zm0-3.08a.25.25 0 0 1-.25-.26v-1.54a.25.25 0 0 1 .25-.25.26.26 0 0 1 .26.25v1.54a.26.26 0 0 1-.26.25Zm0-3.08a.25.25 0 0 1-.25-.26V291a.25.25 0 0 1 .25-.25.26.26 0 0 1 .26.25v1.54a.26.26 0 0 1-.26.29Zm0-3.08a.25.25 0 0 1-.25-.26V288a.25.25 0 0 1 .25-.25.26.26 0 0 1 .26.25v1.54a.26.26 0 0 1-.26.21Zm0-3.08a.25.25 0 0 1-.25-.26v-1.54a.25.25 0 0 1 .25-.25.26.26 0 0 1 .26.25v1.54a.26.26 0 0 1-.26.25Zm0-3.08a.25.25 0 0 1-.25-.26v-1.54a.25.25 0 0 1 .25-.25.26.26 0 0 1 .26.25v1.54a.26.26 0 0 1-.26.25Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "163.106px 290.275px"
    },
    id: "elqvuqju8px2",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.37 306.92a.25.25 0 0 1-.26-.25v-1.54a.26.26 0 1 1 .51 0v1.54a.25.25 0 0 1-.25.25Zm0-3.08a.25.25 0 0 1-.26-.25v-1.54a.26.26 0 1 1 .51 0v1.54a.25.25 0 0 1-.25.25Zm0-3.08a.25.25 0 0 1-.26-.25V299a.26.26 0 1 1 .51 0v1.54a.25.25 0 0 1-.25.22Zm0-3.08a.25.25 0 0 1-.26-.25v-1.54a.26.26 0 1 1 .51 0v1.54a.25.25 0 0 1-.25.25Zm0-3.08a.25.25 0 0 1-.26-.25v-1.54a.26.26 0 1 1 .51 0v1.54a.25.25 0 0 1-.25.25Zm0-3.08a.25.25 0 0 1-.26-.25v-1.54a.26.26 0 1 1 .51 0v1.54a.25.25 0 0 1-.25.25Zm0-3.08a.25.25 0 0 1-.26-.25v-1.54a.26.26 0 1 1 .51 0v1.54a.25.25 0 0 1-.25.25Zm0-3.09a.24.24 0 0 1-.26-.25.26.26 0 1 1 .51 0 .27.27 0 0 1-.25.25Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "149.365px 295.855px"
    },
    id: "elcmum00xsbvm",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.58 283.13a.26.26 0 0 1-.26-.26v-1.54a.26.26 0 0 1 .51 0v1.54a.26.26 0 0 1-.25.26Zm0-3.08a.26.26 0 0 1-.26-.26v-1.54a.26.26 0 0 1 .51 0v1.54a.26.26 0 0 1-.25.26Zm0-3.08a.26.26 0 0 1-.26-.26v-1.54a.26.26 0 0 1 .51 0v1.54a.26.26 0 0 1-.25.29Zm0-3.08a.26.26 0 0 1-.26-.26v-1.54a.26.26 0 0 1 .51 0v1.54a.26.26 0 0 1-.25.26Zm0-3.08a.26.26 0 0 1-.26-.26V269a.26.26 0 0 1 .51 0v1.54a.26.26 0 0 1-.25.27Zm0-3.08a.26.26 0 0 1-.26-.26v-1.54a.26.26 0 0 1 .51 0v1.54a.26.26 0 0 1-.25.26Zm0-3.08a.26.26 0 0 1-.26-.26v-1.54a.26.26 0 0 1 .51 0v1.54a.26.26 0 0 1-.25.26Zm0-3.08a.26.26 0 0 1-.26-.26v-1.54a.26.26 0 0 1 .51 0v1.54a.26.26 0 0 1-.25.26Zm0-3.08a.26.26 0 0 1-.26-.26v-1.54a.26.26 0 0 1 .51 0v1.54a.26.26 0 0 1-.25.26Zm0-3.08a.26.26 0 0 1-.26-.26v-1.51a.26.26 0 1 1 .51 0v1.51a.26.26 0 0 1-.25.26Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "190.575px 268.23px"
    },
    id: "ellvhh6rjwnqp",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.93 252.07c0-.53-.27-.8-.62-.6a1.66 1.66 0 0 0-.62 1.32c0 .53.28.8.62.6a1.63 1.63 0 0 0 .62-1.32Z",
    style: {
      fill: "#e0e0e0",
      transformOrigin: "204.31px 252.43px"
    },
    id: "elqw2vyuyobrl",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.2 253.28c0-.53-.28-.8-.62-.6A1.63 1.63 0 0 0 190 254c0 .53.28.79.63.6a1.66 1.66 0 0 0 .57-1.32Z",
    style: {
      fill: "#e0e0e0",
      transformOrigin: "190.6px 253.638px"
    },
    id: "ele59s9malto4",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.46 265.38c0-.53-.28-.8-.62-.6a1.66 1.66 0 0 0-.62 1.32c0 .52.28.79.62.59a1.62 1.62 0 0 0 .62-1.31Z",
    style: {
      fill: "#e0e0e0",
      transformOrigin: "176.84px 265.735px"
    },
    id: "elvbuwmkms32",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.72 280.8c0-.53-.27-.8-.62-.6a1.64 1.64 0 0 0-.62 1.31c0 .53.28.8.62.6a1.62 1.62 0 0 0 .62-1.31Z",
    style: {
      fill: "#e0e0e0",
      transformOrigin: "163.1px 281.155px"
    },
    id: "elfnwnug89aag",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150 284.72c0-.53-.28-.8-.62-.6a1.63 1.63 0 0 0-.63 1.32c0 .53.28.8.63.6a1.66 1.66 0 0 0 .62-1.32Z",
    style: {
      fill: "#e0e0e0",
      transformOrigin: "149.375px 285.08px"
    },
    id: "elq3gp8ws5rq",
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--check-list--inject-4",
    className: "animable",
    style: {
      transformOrigin: "269.07px 117.52px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M287.84 106.92a.54.54 0 0 1-.27-.07.52.52 0 0 1-.26-.45v-9.24a.5.5 0 0 1 .27-.45l8-4.62a.51.51 0 0 1 .53 0 .53.53 0 0 1 .26.46v9.23a.54.54 0 0 1-.26.46l-8 4.61a.48.48 0 0 1-.27.07Zm.53-9.45v8l6.94-4v-8Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "291.84px 99.4681px"
    },
    id: "el3xeluuqydwa",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    id: "freepik--Check--inject-4",
    d: "M286.92 95.77c.38-.37.71-.33.92-.08l3.67 4.49 1.49-3.05c.24-.53.53-.66.88-.52s.34.54.21.83l-1.89 4c-.18.39-.26.52-.52.57s-.61-.25-.74-.4l-4-4.93a.62.62 0 0 1-.02-.91Z",
    style: {
      fill: "#455a64",
      transformOrigin: "290.452px 98.7564px"
    },
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m281.05 104.31-38 21.94a2.74 2.74 0 0 0-1.28 2.13c0 .77.57 1.06 1.28.65l38-21.94a2.74 2.74 0 0 0 1.27-2.13c0-.76-.57-1.06-1.27-.65Z",
    style: {
      fill: "#455a64",
      transformOrigin: "262.045px 116.671px"
    },
    id: "elubr1xpd1uf",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.84 120.77a.48.48 0 0 1-.26-.07.52.52 0 0 1-.27-.46V111a.53.53 0 0 1 .27-.46l8-4.61a.51.51 0 0 1 .53 0 .52.52 0 0 1 .26.45v9.24a.51.51 0 0 1-.26.45l-8 4.62a.48.48 0 0 1-.27.08Zm.53-9.45v8l6.94-4v-8Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "291.84px 113.313px"
    },
    id: "elqvetkzyrflr",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    id: "freepik--check--inject-4",
    d: "M286.92 109.67c.38-.36.71-.33.92-.08l3.67 4.49 1.46-3c.24-.53.53-.67.88-.52s.34.53.21.83l-1.89 4c-.18.39-.26.52-.52.58s-.61-.26-.74-.41l-4-4.93a.62.62 0 0 1 .01-.96Z",
    style: {
      fill: "#455a64",
      transformOrigin: "290.415px 112.689px"
    },
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m281.05 118.12-38 21.93a2.76 2.76 0 0 0-1.28 2.14c0 .76.57 1.06 1.28.65l38-21.94a2.76 2.76 0 0 0 1.27-2.13c0-.77-.57-1.06-1.27-.65Z",
    style: {
      fill: "#455a64",
      transformOrigin: "262.045px 130.479px"
    },
    id: "ela5weo7j7ge",
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--chart--inject-4",
    className: "animable",
    style: {
      transformOrigin: "190.22px 168.078px"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.15,
      transformOrigin: "190.22px 168.078px"
    },
    className: "animable",
    id: "elzyx3fdfzq3i"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m216.17 125.19-51.9 30a8.11 8.11 0 0 0-3.67 6.37v47.29c0 2.34 1.64 3.29 3.67 2.12l51.9-30a8.13 8.13 0 0 0 3.67-6.37v-47.29c0-2.31-1.64-3.31-3.67-2.12Z",
    id: "el902w3zme2hr",
    className: "animable",
    style: {
      transformOrigin: "190.22px 168.078px"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M196.84 161.66h.13a.18.18 0 0 1 .06.15v.65a.42.42 0 0 1-.06.21.28.28 0 0 1-.13.15l-2.19 1.26 1.62 4a.22.22 0 0 1 0 .1.42.42 0 0 1-.06.21.39.39 0 0 1-.13.15l-.58.33h-.13a.41.41 0 0 1-.07-.11l-1.62-4c0-.09-.06-.16-.08-.21a.52.52 0 0 1 0-.18v-.61a.39.39 0 0 1 .06-.2.28.28 0 0 1 .13-.15Z",
    style: {
      fill: "#455a64",
      transformOrigin: "195.311px 165.265px"
    },
    id: "elyechsaiwerq",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.4 167.37a3.75 3.75 0 0 1 .32-1 3.38 3.38 0 0 1 .57-.86 3.27 3.27 0 0 1 .86-.68 1.81 1.81 0 0 1 .86-.3.8.8 0 0 1 .57.21 1.44 1.44 0 0 1 .32.63 6 6 0 0 1 .12.94v1.6a9.21 9.21 0 0 1-.12 1.07 4.68 4.68 0 0 1-.32 1 3.78 3.78 0 0 1-.57.86 3.52 3.52 0 0 1-.86.69 2.06 2.06 0 0 1-.86.3.69.69 0 0 1-.57-.2 1.15 1.15 0 0 1-.32-.61 4.2 4.2 0 0 1-.12-.93v-1.65a6.26 6.26 0 0 1 .12-1.07Zm2.69.27v-.77a1.57 1.57 0 0 0-.24-.9c-.14-.16-.37-.15-.69 0a1.56 1.56 0 0 0-.7.76 3.91 3.91 0 0 0-.24 1.18v1.56a1.7 1.7 0 0 0 .24.89c.14.17.37.15.7 0a1.65 1.65 0 0 0 .69-.77 3.28 3.28 0 0 0 .24-1.17v-.78Z",
    style: {
      fill: "#455a64",
      transformOrigin: "191.15px 168.182px"
    },
    id: "eljmd2rdmwjkj",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188 166.82a.47.47 0 0 1 .32.08.56.56 0 0 1 .2.25 1.51 1.51 0 0 1 .08.38v1.03a2.89 2.89 0 0 1-.08.47 2.22 2.22 0 0 1-.2.48 2 2 0 0 1-.76.8 1.07 1.07 0 0 1-.45.16.45.45 0 0 1-.31-.08.54.54 0 0 1-.2-.26 1.34 1.34 0 0 1-.08-.37v-1.03a2.89 2.89 0 0 1 .08-.47 2.22 2.22 0 0 1 .2-.48 2.26 2.26 0 0 1 .31-.45 2 2 0 0 1 .45-.36.92.92 0 0 1 .44-.15Zm.21 6a.34.34 0 0 1 0 .17.34.34 0 0 1-.12.12l-.42.24a.21.21 0 0 1-.15 0 .3.3 0 0 1-.1-.07l-3.42-3.9v-.05a.31.31 0 0 1 .16-.28l.42-.24a.24.24 0 0 1 .15 0 .3.3 0 0 1 .1.07Zm-.93-3.31c0 .06.15.05.28 0a.65.65 0 0 0 .28-.29 1.12 1.12 0 0 0 .09-.36s0-.11 0-.19V168a.44.44 0 0 0-.09-.26c-.05-.06-.15-.05-.28 0a.65.65 0 0 0-.28.29 1.12 1.12 0 0 0-.09.37s0 .1 0 .18v.67a.44.44 0 0 0 .08.29Zm-2.28 2.3a.48.48 0 0 1 .32.08.51.51 0 0 1 .19.26 1 1 0 0 1 .08.38v1.03a1.71 1.71 0 0 1-.08.47 1.92 1.92 0 0 1-.19.48 2.24 2.24 0 0 1-.32.44 1.51 1.51 0 0 1-.44.35 1.1 1.1 0 0 1-.45.17.51.51 0 0 1-.31-.08.59.59 0 0 1-.2-.26 1.42 1.42 0 0 1-.08-.38v-1.02a3 3 0 0 1 .08-.48 2.45 2.45 0 0 1 .2-.48 2.26 2.26 0 0 1 .31-.45 2 2 0 0 1 .45-.36 1 1 0 0 1 .44-.15Zm-.72 2.73c.05.05.14.05.28 0a.7.7 0 0 0 .28-.29 1.18 1.18 0 0 0 .09-.37 1.36 1.36 0 0 1 0-.18v-.5a1.31 1.31 0 0 1 0-.17.48.48 0 0 0-.09-.27c0-.06-.15 0-.28 0a.65.65 0 0 0-.28.29 1.18 1.18 0 0 0-.09.37.87.87 0 0 0 0 .18v.5a.72.72 0 0 0 0 .17.48.48 0 0 0 .07.27Z",
    style: {
      fill: "#455a64",
      transformOrigin: "186.06px 171.144px"
    },
    id: "el8qw6c8r17g",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m196.7 152.42 2.3-5.54c2.52 1 4.45 3.35 5.43 6.82l-3.71 3.75c-.72-2.56-2.15-4.3-4.02-5.03Z",
    style: {
      fill: "#455a64",
      transformOrigin: "200.565px 152.165px"
    },
    id: "elisnebdjruxg",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.22 153.34v-5.2c3.28-1.9 6.31-2.23 8.78-1.26l-2.3 5.54c-1.82-.72-4.05-.48-6.48.92Z",
    style: {
      fill: "#455a64",
      transformOrigin: "194.61px 149.845px"
    },
    id: "elfds2n656jgf",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.26 161.68a15.51 15.51 0 0 0-.54-4.23l3.71-3.75a21.09 21.09 0 0 1 .73 5.73 31.81 31.81 0 0 1-.73 6.58l-3.71.53a23.27 23.27 0 0 0 .54-4.86Z",
    style: {
      fill: "#455a64",
      transformOrigin: "202.941px 160.12px"
    },
    id: "elkbbzpdac9g",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.3,
      transformOrigin: "189.839px 168.954px"
    },
    className: "animable",
    id: "el5f3icn2423l"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M176 170.11a40 40 0 0 1 5.43-13.1 27.16 27.16 0 0 1 8.78-8.87v5.2a20 20 0 0 0-6.48 6.56 29.52 29.52 0 0 0-4 9.67 23.27 23.27 0 0 0-.54 4.86 15.46 15.46 0 0 0 .54 4.23 7.16 7.16 0 0 0 4 5c1.82.71 4 .48 6.48-.92a20.05 20.05 0 0 0 6.48-6.57 29.34 29.34 0 0 0 4-9.67l3.71-.53a39.82 39.82 0 0 1-5.4 13.13 27.29 27.29 0 0 1-8.78 8.88c-3.28 1.89-6.32 2.23-8.78 1.26s-4.45-3.35-5.43-6.82a21.22 21.22 0 0 1-.73-5.74 31.71 31.71 0 0 1 .72-6.57Z",
    id: "elnzx9uetzoa",
    className: "animable",
    style: {
      transformOrigin: "189.839px 168.954px"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    className: "animable",
    style: {
      transformOrigin: "119.437px 209.083px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "m145.64 166-25.94 15v8c3.28-1.89 6.31-2.23 8.78-1.26s4.44 3.35 5.42 6.82a20.83 20.83 0 0 1 .73 5.74 31 31 0 0 1-.73 6.57 39.94 39.94 0 0 1-5.42 13.1 27.35 27.35 0 0 1-8.78 8.87v8l25.94-15a8.12 8.12 0 0 0 3.68-6.37v-47.4c0-2.34-1.65-3.29-3.68-2.07Z",
    style: {
      opacity: 0.15,
      transformOrigin: "134.51px 201.153px"
    },
    className: "animable",
    id: "ela3movyzznwk"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.32 211.3a1.54 1.54 0 0 0 .69-.76 3.28 3.28 0 0 0 .24-1.17v-1.56a1.57 1.57 0 0 0-.24-.9c-.13-.16-.37-.15-.69 0a1.68 1.68 0 0 0-.62.65v3.81c.14.12.35.09.62-.07Z",
    style: {
      opacity: 0.15,
      transformOrigin: "120.476px 209.119px"
    },
    className: "animable",
    id: "elv596t3dymxe"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.32 205.79a1.81 1.81 0 0 1 .86-.3.8.8 0 0 1 .57.21 1.34 1.34 0 0 1 .32.63 4.3 4.3 0 0 1 .12.94v1.6a6.26 6.26 0 0 1-.12 1.07 4.17 4.17 0 0 1-.32 1 3.78 3.78 0 0 1-.57.86 3.27 3.27 0 0 1-.86.68 2.23 2.23 0 0 1-.62.26v10.82a20.21 20.21 0 0 0 6.48-6.56 29.71 29.71 0 0 0 4-9.67 23.34 23.34 0 0 0 .54-4.86 15.59 15.59 0 0 0-.54-4.24 7.17 7.17 0 0 0-4-5c-1.82-.71-4.05-.48-6.48.92v12.14a4.1 4.1 0 0 1 .62-.5Zm2.68 2.37a2.76 2.76 0 0 1 .28-.72 3.41 3.41 0 0 1 .43-.64 4.11 4.11 0 0 1 .57-.53l-1-.84-.1-.09a.28.28 0 0 1 0-.16v-.66a.54.54 0 0 1 0-.21.41.41 0 0 1 .14-.15l3-1.76a.12.12 0 0 1 .14 0 .2.2 0 0 1 0 .14v.66a.54.54 0 0 1 0 .21.34.34 0 0 1-.14.15l-1.92 1.11 1 .8.1.09a.29.29 0 0 1 0 .17v.65a.42.42 0 0 1-.06.21.32.32 0 0 1-.13.15l-.57.34a2.19 2.19 0 0 0-.69.57 1.2 1.2 0 0 0-.26.75c0 .28.09.45.26.49a.9.9 0 0 0 .69-.16 3.82 3.82 0 0 0 .42-.3 1.59 1.59 0 0 0 .29-.29 1.1 1.1 0 0 0 .18-.28 1 1 0 0 0 .11-.27l.1-.23a.36.36 0 0 1 .11-.13l.55-.31a.14.14 0 0 1 .14 0s.06.07 0 .15a2.39 2.39 0 0 1-.15.69 3.47 3.47 0 0 1-.36.76 4.43 4.43 0 0 1-.6.74 4.64 4.64 0 0 1-.84.64 2.45 2.45 0 0 1-.75.29 1.07 1.07 0 0 1-.6-.05.88.88 0 0 1-.4-.41 1.91 1.91 0 0 1-.14-.78 3 3 0 0 1 .2-.79Z",
    style: {
      opacity: 0.15,
      transformOrigin: "125.21px 208.2px"
    },
    className: "animable",
    id: "elzpicjohmdab"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.44 210.13a1.07 1.07 0 0 0 .6.05 2.45 2.45 0 0 0 .75-.29 4.64 4.64 0 0 0 .84-.64 4.43 4.43 0 0 0 .6-.74 3.47 3.47 0 0 0 .36-.76 2.39 2.39 0 0 0 .15-.69v-.15a.14.14 0 0 0-.14 0l-.55.31a.36.36 0 0 0-.11.13l-.1.23a1 1 0 0 1-.11.27 1.1 1.1 0 0 1-.18.28 1.59 1.59 0 0 1-.29.29 3.82 3.82 0 0 1-.42.3.9.9 0 0 1-.69.16c-.17 0-.26-.21-.26-.49a1.2 1.2 0 0 1 .26-.75 2.19 2.19 0 0 1 .69-.57l.57-.34a.32.32 0 0 0 .13-.15.42.42 0 0 0 .06-.21v-.65a.29.29 0 0 0 0-.17l-.1-.09-1-.8 1.92-1.11a.34.34 0 0 0 .14-.15.54.54 0 0 0 0-.21v-.66a.2.2 0 0 0 0-.14.12.12 0 0 0-.14 0l-3 1.76a.41.41 0 0 0-.14.15.54.54 0 0 0 0 .21v.66a.28.28 0 0 0 0 .16l.1.09 1 .84a4.11 4.11 0 0 0-.57.53 3.41 3.41 0 0 0-.43.64 2.76 2.76 0 0 0-.28.72 3 3 0 0 0-.1.78 1.91 1.91 0 0 0 .14.78.88.88 0 0 0 .3.42Z",
    style: {
      fill: "#455a64",
      transformOrigin: "124.87px 206.285px"
    },
    id: "elvvar6vep0wn",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.18 211.78a3.78 3.78 0 0 0 .57-.86 4.17 4.17 0 0 0 .32-1 6.26 6.26 0 0 0 .12-1.07v-1.6a4.3 4.3 0 0 0-.12-.94 1.34 1.34 0 0 0-.32-.63.8.8 0 0 0-.57-.21 1.81 1.81 0 0 0-.86.3 4.1 4.1 0 0 0-.62.45v1.35a1.68 1.68 0 0 1 .62-.65c.32-.18.56-.19.69 0a1.57 1.57 0 0 1 .24.9v1.56a3.28 3.28 0 0 1-.24 1.17 1.54 1.54 0 0 1-.69.76c-.27.16-.48.19-.62.1v1.32a2.23 2.23 0 0 0 .62-.26 3.27 3.27 0 0 0 .86-.69Z",
    style: {
      fill: "#455a64",
      transformOrigin: "120.945px 209.1px"
    },
    id: "elq48lwkfqb2r",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m130.19 198.21 3.71-3.75c-1-3.47-2.9-5.83-5.42-6.82l-2.3 5.54a7.17 7.17 0 0 1 4.01 5.03Z",
    style: {
      fill: "#455a64",
      transformOrigin: "130.04px 192.925px"
    },
    id: "eldeluudpk2bd",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m126.18 193.18 2.3-5.54c-2.47-1-5.5-.63-8.78 1.26v5.2c2.43-1.4 4.66-1.63 6.48-.92Z",
    style: {
      fill: "#455a64",
      transformOrigin: "124.09px 190.6px"
    },
    id: "elvus8agez4f",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.73 202.45a23.34 23.34 0 0 1-.54 4.86l3.71-.54a31 31 0 0 0 .73-6.57 20.83 20.83 0 0 0-.73-5.74l-3.71 3.75a15.59 15.59 0 0 1 .54 4.24Z",
    style: {
      fill: "#455a64",
      transformOrigin: "132.411px 200.885px"
    },
    id: "elsjp7wttv7u",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.7 223.54v5.2a27.35 27.35 0 0 0 8.78-8.87l-2.3-2.89a20.21 20.21 0 0 1-6.48 6.56Z",
    style: {
      fill: "#455a64",
      transformOrigin: "124.09px 222.86px"
    },
    id: "el8woqkpqgzt4",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m126.18 217 2.3 2.89a39.94 39.94 0 0 0 5.42-13.1l-3.71.54a29.71 29.71 0 0 1-4.01 9.67Z",
    style: {
      fill: "#455a64",
      transformOrigin: "130.04px 213.34px"
    },
    id: "elc6befdke4z",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.69 228.74c-3.28 1.9-6.31 2.23-8.78 1.26s-4.44-3.35-5.42-6.82a20.76 20.76 0 0 1-.73-5.73 31.14 31.14 0 0 1 .73-6.58 39.8 39.8 0 0 1 5.42-13.09 27.29 27.29 0 0 1 8.78-8.88v-8l-25.95 15a8.14 8.14 0 0 0-3.68 6.37v47.29c0 2.35 1.65 3.3 3.68 2.12l26-15v-8Z",
    style: {
      fill: "#fafafa",
      transformOrigin: "104.9px 216.544px"
    },
    id: "el10agxmgsf0w",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.1 252.7a2.37 2.37 0 0 1-1.2-.32 3 3 0 0 1-1.33-2.81v-47.29a8.57 8.57 0 0 1 3.93-6.8l26.2-15.15v1.17L94 196.34a7.6 7.6 0 0 0-3.43 5.94v47.29a1.76 1.76 0 0 0 2.93 1.69l26.19-15.15v1.18L94 252.13a3.83 3.83 0 0 1-1.9.57Z",
    style: {
      fill: "#e0e0e0",
      transformOrigin: "104.627px 216.515px"
    },
    id: "el4i4fo2xv0p",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.39 208.88v1.56a1.57 1.57 0 0 0 .24.9s.05 0 .07.06v-3.81l-.07.12a3.32 3.32 0 0 0-.24 1.17Z",
    style: {
      fill: "#fafafa",
      transformOrigin: "119.544px 209.495px"
    },
    id: "el6q9tqsjv38e",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.08 213.93a.47.47 0 0 0-.09-.26c0-.06-.15 0-.28 0a.65.65 0 0 0-.28.29 1.18 1.18 0 0 0-.09.37s0 .1 0 .18v.67a.48.48 0 0 0 .09.27c0 .05.14.05.28 0a.67.67 0 0 0 .28-.3 1.06 1.06 0 0 0 .09-.36s0-.1 0-.19v-.5c.01-.1 0-.1 0-.17Z",
    style: {
      fill: "#fafafa",
      transformOrigin: "113.712px 214.565px"
    },
    id: "elp326z7jy1fm",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.21 200.67a29.57 29.57 0 0 0-4 9.66 23.44 23.44 0 0 0-.54 4.87 15.51 15.51 0 0 0 .54 4.23c.73 2.56 2.15 4.3 4 5s4.06.48 6.48-.92v-10.79a1.14 1.14 0 0 1-.24.05.74.74 0 0 1-.57-.2 1.22 1.22 0 0 1-.32-.61 4.2 4.2 0 0 1-.12-.93v-1.65a6.26 6.26 0 0 1 .12-1.07 4.17 4.17 0 0 1 .32-1 3.48 3.48 0 0 1 .57-.86c.07-.08.16-.15.24-.23V194.1a20.15 20.15 0 0 0-6.48 6.57Zm1.54 13.82a2.72 2.72 0 0 1-.08.47 2.3 2.3 0 0 1-.2.49 2.19 2.19 0 0 1-.31.44 1.7 1.7 0 0 1-.45.35.94.94 0 0 1-.45.16.45.45 0 0 1-.31-.07.59.59 0 0 1-.2-.26 1.51 1.51 0 0 1-.08-.38v-1.03a2.89 2.89 0 0 1 .08-.47 2.45 2.45 0 0 1 .2-.48 2.26 2.26 0 0 1 .31-.45 2 2 0 0 1 .45-.36 1 1 0 0 1 .45-.15.45.45 0 0 1 .31.08.59.59 0 0 1 .2.26 1.42 1.42 0 0 1 .08.38v.5c0 .18.01.36 0 .52Zm2.6-.45a.34.34 0 0 1-.12.12l-.42.24a.24.24 0 0 1-.15 0l-.1-.08-3.43-4a.09.09 0 0 1 0-.05.32.32 0 0 1 0-.16.34.34 0 0 1 .12-.12l.42-.24c.07 0 .12-.05.15 0a.23.23 0 0 1 .1.07l3.44 4a.37.37 0 0 1-.01.18Zm-.63-6.13a1.07 1.07 0 0 1 .45-.16.52.52 0 0 1 .31.09.56.56 0 0 1 .2.25 1.51 1.51 0 0 1 .08.38v1.03a2.89 2.89 0 0 1-.08.47 2.22 2.22 0 0 1-.2.48 1.94 1.94 0 0 1-.31.44 2 2 0 0 1-.45.36 1.08 1.08 0 0 1-.44.16.48.48 0 0 1-.32-.08.47.47 0 0 1-.19-.26 1.11 1.11 0 0 1-.08-.37v-1.03a2 2 0 0 1 .08-.47 1.66 1.66 0 0 1 .19-.48 2.31 2.31 0 0 1 .32-.45 1.73 1.73 0 0 1 .44-.36Z",
    style: {
      fill: "#fafafa",
      transformOrigin: "114.18px 209.458px"
    },
    id: "eli94z6h4fsf",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.45 210.48c0 .06.14.05.27 0a.6.6 0 0 0 .28-.29 1.12 1.12 0 0 0 .09-.37.87.87 0 0 0 0-.18v-.5a.72.72 0 0 0 0-.17.42.42 0 0 0-.09-.26c0-.06-.14-.05-.28 0a.54.54 0 0 0-.27.29.93.93 0 0 0-.1.37v.85a.39.39 0 0 0 .1.26Z",
    style: {
      fill: "#fafafa",
      transformOrigin: "116.723px 209.595px"
    },
    id: "elopk4eyjomfb",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.63 211.34a1.57 1.57 0 0 1-.24-.9v-1.56a3.32 3.32 0 0 1 .24-1.17l.07-.12v-1.35c-.08.08-.17.15-.24.23a3.48 3.48 0 0 0-.57.86 4.17 4.17 0 0 0-.32 1 6.26 6.26 0 0 0-.12 1.07v1.65a4.2 4.2 0 0 0 .12.93 1.22 1.22 0 0 0 .32.61.74.74 0 0 0 .57.2 1.14 1.14 0 0 0 .24-.05v-1.34s-.05-.03-.07-.06Z",
    style: {
      fill: "#e0e0e0",
      transformOrigin: "119.075px 209.516px"
    },
    id: "elu0yo2kad1w",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.77 209.2a2 2 0 0 0-.08.47v1.03a1.11 1.11 0 0 0 .08.37.47.47 0 0 0 .19.26.48.48 0 0 0 .32.08 1.08 1.08 0 0 0 .44-.16 2 2 0 0 0 .45-.36 1.94 1.94 0 0 0 .31-.44 2.22 2.22 0 0 0 .2-.48 2.89 2.89 0 0 0 .08-.47v-1.03a1.51 1.51 0 0 0-.08-.38.56.56 0 0 0-.2-.25.52.52 0 0 0-.31-.09 1.07 1.07 0 0 0-.45.16 1.73 1.73 0 0 0-.44.36 2.31 2.31 0 0 0-.32.45 1.66 1.66 0 0 0-.19.48Zm.58.6v-.43a.93.93 0 0 1 .1-.37.54.54 0 0 1 .27-.29c.14-.08.23-.09.28 0a.42.42 0 0 1 .09.26.72.72 0 0 1 0 .17v.5a.87.87 0 0 1 0 .18 1.12 1.12 0 0 1-.09.37.6.6 0 0 1-.28.29c-.13.08-.23.09-.27 0a.39.39 0 0 1-.1-.26v-.42Z",
    style: {
      fill: "#e0e0e0",
      transformOrigin: "116.725px 209.581px"
    },
    id: "eliuryl11t51",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.67 213.09a.59.59 0 0 0-.2-.26.45.45 0 0 0-.31-.08 1 1 0 0 0-.45.15 2 2 0 0 0-.45.36 2.26 2.26 0 0 0-.31.45 2.45 2.45 0 0 0-.2.48 2.89 2.89 0 0 0-.08.47v1.03a1.51 1.51 0 0 0 .08.38.59.59 0 0 0 .2.26.45.45 0 0 0 .31.07.94.94 0 0 0 .45-.16 1.7 1.7 0 0 0 .45-.35 2.19 2.19 0 0 0 .31-.44 2.3 2.3 0 0 0 .2-.49 2.72 2.72 0 0 0 .08-.47v-1.02a1.42 1.42 0 0 0-.08-.38Zm-.58 1.51v.19a1.06 1.06 0 0 1-.09.36.67.67 0 0 1-.28.3c-.14.08-.23.08-.28 0a.48.48 0 0 1-.09-.27s0-.09 0-.17V214.33a1.18 1.18 0 0 1 .09-.37.65.65 0 0 1 .28-.29c.13-.07.23-.09.28 0a.47.47 0 0 1 .09.26s0 .1 0 .17v.5Z",
    style: {
      fill: "#e0e0e0",
      transformOrigin: "113.71px 214.576px"
    },
    id: "el9dlkhp9yyhu",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m117.37 213.79-3.44-4a.23.23 0 0 0-.1-.07s-.08 0-.15 0l-.42.24a.34.34 0 0 0-.12.12.32.32 0 0 0 0 .16.09.09 0 0 0 0 .05l3.43 4 .1.08a.24.24 0 0 0 .15 0l.42-.24a.34.34 0 0 0 .12-.12.37.37 0 0 0 .05-.17.08.08 0 0 0-.04-.05Z",
    style: {
      fill: "#e0e0e0",
      transformOrigin: "115.27px 212.051px"
    },
    id: "elwvvtr34i7dc",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b0bec5",
      transformOrigin: "119.695px 191.5px"
    },
    id: "eluey1eia6iz",
    className: "animable",
    d: "M119.69 194.1h.01v-5.2h-.01v5.2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.66 215.2a23.44 23.44 0 0 1 .54-4.87 29.57 29.57 0 0 1 4-9.66 20.15 20.15 0 0 1 6.48-6.57v-5.2a27.29 27.29 0 0 0-8.78 8.88 39.8 39.8 0 0 0-5.42 13.09 31.14 31.14 0 0 0-.73 6.58 20.76 20.76 0 0 0 .73 5.73l3.71-3.75a15.51 15.51 0 0 1-.53-4.23Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "112.214px 206.04px"
    },
    id: "ello77z444sq",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m109.2 219.43-3.71 3.75c1 3.47 2.9 5.83 5.42 6.82l2.3-5.54c-1.86-.73-3.28-2.46-4.01-5.03Z",
    style: {
      fill: "#e0e0e0",
      transformOrigin: "109.35px 224.715px"
    },
    id: "el2m9kurhic7z",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b0bec5",
      transformOrigin: "119.695px 226.135px"
    },
    id: "elragbc619pz",
    className: "animable",
    d: "M119.69 223.54v5.2h.01v-5.21l-.01.01z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m113.21 224.46-2.3 5.54c2.47 1 5.5.64 8.78-1.26v-5.2c-2.42 1.4-4.69 1.64-6.48.92Z",
    style: {
      fill: "#e0e0e0",
      transformOrigin: "115.3px 227.041px"
    },
    id: "eli7mz881m3u",
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--text-box--inject-4",
    className: "animable",
    style: {
      transformOrigin: "198.917px 211.157px"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.3,
      transformOrigin: "198.917px 211.157px"
    },
    className: "animable",
    id: "eli58m7kvllzf"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M183.63 231.87a1.13 1.13 0 0 1-.57-.15 1.38 1.38 0 0 1-.62-1.26v-20.12a3.35 3.35 0 0 1 1.52-2.65l29.43-17a1.26 1.26 0 0 1 2 1.16V212a3.32 3.32 0 0 1-1.52 2.64l-29.43 17a1.61 1.61 0 0 1-.81.23Zm30.57-40.42a.7.7 0 0 0-.32.11l-29.43 17a2.34 2.34 0 0 0-1 1.79v20.12c0 .25.07.37.13.41s.2 0 .41-.09l29.43-17a2.37 2.37 0 0 0 1-1.79v-20.13c0-.24-.07-.37-.13-.4Z",
    id: "elmsqz1f7l8l",
    className: "animable",
    style: {
      transformOrigin: "198.917px 211.157px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.3,
      transformOrigin: "198.922px 211.168px"
    },
    className: "animable",
    id: "elsticy10yes"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M186.93 213.94a.49.49 0 0 1-.25-.92l24-13.85a.49.49 0 0 1 .49.86l-24 13.84a.42.42 0 0 1-.24.07Z",
    id: "el64xdzn5daa4",
    className: "animable",
    style: {
      transformOrigin: "198.922px 206.523px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.93 218.58a.49.49 0 0 1-.25-.91l24-13.85a.48.48 0 0 1 .67.18.49.49 0 0 1-.18.67l-24 13.85a.5.5 0 0 1-.24.06Z",
    id: "elrvprzhxxe8q",
    className: "animable",
    style: {
      transformOrigin: "198.929px 211.165px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.93 223.23a.49.49 0 0 1-.25-.92l24-13.85a.5.5 0 0 1 .67.18.49.49 0 0 1-.18.67l-24 13.85a.42.42 0 0 1-.24.07Z",
    id: "el8w32ucb7ecl",
    className: "animable",
    style: {
      transformOrigin: "198.92px 215.814px"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    className: "animable",
    style: {
      transformOrigin: "154.95px 236.554px"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.3,
      transformOrigin: "154.95px 236.554px"
    },
    className: "animable",
    id: "elkux74nw98aa"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M139.66 257.26a1.13 1.13 0 0 1-.57-.15 1.38 1.38 0 0 1-.62-1.26v-20.13a3.35 3.35 0 0 1 1.52-2.64l29.42-17a1.39 1.39 0 0 1 1.4-.08 1.37 1.37 0 0 1 .62 1.25v20.13a3.34 3.34 0 0 1-1.53 2.62l-29.42 17a1.61 1.61 0 0 1-.82.26Zm30.57-40.42a.7.7 0 0 0-.33.11l-29.42 17a2.37 2.37 0 0 0-1 1.79v20.13c0 .24.07.37.13.4s.2 0 .41-.09l29.42-17a2.33 2.33 0 0 0 1-1.78v-20.14c0-.24-.06-.37-.12-.4Z",
    id: "elkoyzzocsdia",
    className: "animable",
    style: {
      transformOrigin: "154.95px 236.554px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.3,
      transformOrigin: "155.005px 236.559px"
    },
    className: "animable",
    id: "el019lgg95h3qd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M143 239.33a.49.49 0 0 1-.24-.92l24-13.85a.51.51 0 0 1 .68.18.5.5 0 0 1-.18.67l-24 13.85a.45.45 0 0 1-.26.07Z",
    id: "elrr3d2jhpsvd",
    className: "animable",
    style: {
      transformOrigin: "155.004px 231.914px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143 244a.49.49 0 0 1-.24-.92l24-13.84a.49.49 0 0 1 .68.18.5.5 0 0 1-.18.67l-24 13.84a.45.45 0 0 1-.26.07Z",
    id: "elrj8zqrcm1h",
    className: "animable",
    style: {
      transformOrigin: "155.004px 236.585px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143 248.62a.49.49 0 0 1-.24-.92l24-13.85a.49.49 0 1 1 .5.85l-24 13.85a.55.55 0 0 1-.26.07Z",
    id: "elr2ynvvr74mk",
    className: "animable",
    style: {
      transformOrigin: "155.005px 241.2px"
    }
  }))))), /*#__PURE__*/React.createElement("g", {
    className: "animable animator-active",
    style: {
      transformOrigin: "327.985px 217.395px"
    }
  }, /*#__PURE__*/React.createElement("g", {
    className: "animable",
    style: {
      transformOrigin: "327.985px 217.395px"
    }
  }, /*#__PURE__*/React.createElement("g", {
    className: "animable",
    style: {
      transformOrigin: "323.231px 217.395px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M410.81 72.64a2.8 2.8 0 0 0-1.22-2.64l-3.15-1.79a2.79 2.79 0 0 0-2.88.25L239.65 163.1a8.88 8.88 0 0 0-4 7V362a2.81 2.81 0 0 0 1.2 2.61l3.22 1.84a2.84 2.84 0 0 0 2.85-.28l163.9-94.63a8.86 8.86 0 0 0 4-7Z",
    style: {
      fill: "#b0bec5",
      opacity: 0.1,
      transformOrigin: "323.231px 217.316px"
    },
    className: "animable",
    id: "elogmrs5jswpk"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.79 70.32 242.9 165a8.88 8.88 0 0 0-4 7v192c0 2.56 1.8 3.6 4 2.32l163.9-94.63a8.86 8.86 0 0 0 4-7v-192c.01-2.61-1.8-3.69-4.01-2.37Z",
    style: {
      fill: "#b0bec5",
      opacity: 0.1,
      transformOrigin: "324.85px 218.312px"
    },
    className: "animable",
    id: "el7rz4x3grsgy"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M410.81 72.64v192a8.89 8.89 0 0 1-4 7L242.9 366.2c-2 1.13-3.61.45-4-1.51a4.15 4.15 0 0 0 .71-.34l163.91-94.62a8.92 8.92 0 0 0 4-7v-192a4.14 4.14 0 0 0-.07-.81c1.93-.63 3.36.44 3.36 2.72Z",
    style: {
      fill: "#b0bec5",
      opacity: 0.15,
      transformOrigin: "324.855px 218.244px"
    },
    className: "animable",
    id: "elo3zuta15anl"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.79 70.32 364.83 95l-42.06 24.56L280.64 144l-21.06 12.21-10.58 6.07-5.27 3a7.81 7.81 0 0 0-3.6 4.13 6.57 6.57 0 0 0-.54 2.69V217.75l-.14 48.7-.2 48.69-.33 48.7-.33-48.7-.21-48.69-.14-48.7V172.1a8.14 8.14 0 0 1 .63-3.24 10.45 10.45 0 0 1 1.67-2.8 10 10 0 0 1 1.18-1.17A10.68 10.68 0 0 1 243 164l5.27-3.05 10.53-6.1 21.11-12.14 42.21-24.28 42.3-24.14Z",
    style: {
      fill: "#fff",
      transformOrigin: "322.515px 217.08px"
    },
    id: "elvzflh1jtw7j",
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    className: "animable",
    style: {
      transformOrigin: "294.845px 190.783px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "m257 178 75.69-43.7c1.18-.67 2.13-.12 2.13 1.24v64.31a4.7 4.7 0 0 1-2.13 3.69L257 247.26c-1.18.68-2.13.13-2.13-1.23v-64.32A4.71 4.71 0 0 1 257 178Z",
    style: {
      fill: "#fafafa",
      transformOrigin: "294.845px 190.783px"
    },
    id: "elqzqk79dn919",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264 231.71v1a4.48 4.48 0 0 1-.07.64 2.17 2.17 0 0 1-.17.58 1.71 1.71 0 0 1-.3.5 1.65 1.65 0 0 1-.45.37.79.79 0 0 1-.45.15.42.42 0 0 1-.3-.15.88.88 0 0 1-.17-.39 2.37 2.37 0 0 1-.06-.57v-.97a3.49 3.49 0 0 1 .06-.65 2.7 2.7 0 0 1 .17-.59 1.8 1.8 0 0 1 .3-.5 1.55 1.55 0 0 1 .45-.39.85.85 0 0 1 .45-.14.34.34 0 0 1 .3.15.79.79 0 0 1 .17.38 3.17 3.17 0 0 1 .07.58Zm-1.48 1.83a1.07 1.07 0 0 0 .13.56c.07.1.19.11.36 0a.91.91 0 0 0 .37-.43 2.39 2.39 0 0 0 .12-.71v-.94a1.16 1.16 0 0 0-.12-.56c-.08-.11-.2-.11-.37 0a.8.8 0 0 0-.36.43 2 2 0 0 0-.13.7v.95Z",
    style: {
      fill: "#455a64",
      transformOrigin: "263.015px 232.775px"
    },
    id: "elpkqs25hx4gh",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.51 230a.51.51 0 0 1-.43-.24.5.5 0 0 1 .18-.68l57.21-33a.5.5 0 0 1 .5.86l-57.22 33a.5.5 0 0 1-.24.06Z",
    style: {
      fill: "#e0e0e0",
      transformOrigin: "298.095px 213.018px"
    },
    id: "elouekitdz599",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.07 217.39a.3.3 0 0 1 0-.1.5.5 0 0 1 0-.13l.8-1.42.06-.1a.22.22 0 0 1 .06-.07l.29-.17a.06.06 0 0 1 .07 0 .12.12 0 0 1 0 .09v3.64a.35.35 0 0 1 0 .13s0 .07-.07.08l-.3.17h-.07a.12.12 0 0 1 0-.09v-2.79l-.52.93a.12.12 0 0 1-.07.07.07.07 0 0 1-.07 0Z",
    style: {
      fill: "#455a64",
      transformOrigin: "261.712px 217.449px"
    },
    id: "elzt2gv4z032l",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.83 215.41v1.01c0 .08 0 .43-.06.64a3.28 3.28 0 0 1-.17.58 2.29 2.29 0 0 1-.3.5 1.62 1.62 0 0 1-.45.37.84.84 0 0 1-.46.15.44.44 0 0 1-.3-.15 1 1 0 0 1-.17-.39 4.18 4.18 0 0 1-.06-.56v-.98c0-.14 0-.44.06-.65a3.39 3.39 0 0 1 .17-.59 2.29 2.29 0 0 1 .3-.5 1.61 1.61 0 0 1 .46-.39.82.82 0 0 1 .45-.14.4.4 0 0 1 .3.15 1 1 0 0 1 .17.39 4.18 4.18 0 0 1 .06.56Zm-1.47 1.83a1.19 1.19 0 0 0 .12.56c.07.1.19.11.37 0a.8.8 0 0 0 .36-.43 2.65 2.65 0 0 0 .13-.71v-.94a1.27 1.27 0 0 0-.13-.56c-.07-.11-.19-.11-.36 0a.78.78 0 0 0-.37.43 2.32 2.32 0 0 0-.12.7v.48c0 .17-.01.33 0 .47Z",
    style: {
      fill: "#455a64",
      transformOrigin: "263.845px 216.485px"
    },
    id: "elz674dlvh3mf",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.51 214.19a.49.49 0 0 1-.25-.92l57.21-33a.49.49 0 0 1 .68.18.5.5 0 0 1-.18.67l-57.22 33a.42.42 0 0 1-.24.07Z",
    style: {
      fill: "#e0e0e0",
      transformOrigin: "298.108px 197.195px"
    },
    id: "elhroexjlhfkj",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.05 201.47a1.34 1.34 0 0 0 .14-.35 1.58 1.58 0 0 0 0-.28.51.51 0 0 0-.09-.34c-.06-.07-.17-.07-.31 0a.72.72 0 0 0-.29.33 1.91 1.91 0 0 0-.14.46.29.29 0 0 1 0 .14.14.14 0 0 1-.06.07l-.29.17a.06.06 0 0 1-.08 0s0-.05 0-.1a1.93 1.93 0 0 1 .08-.52 2.25 2.25 0 0 1 .2-.51 2.28 2.28 0 0 1 .28-.43 1.29 1.29 0 0 1 .36-.31.61.61 0 0 1 .4-.11.4.4 0 0 1 .28.14.75.75 0 0 1 .16.31 1.36 1.36 0 0 1 0 .41 2.44 2.44 0 0 1 0 .27 1 1 0 0 1-.05.29 1.92 1.92 0 0 1-.12.33c0 .12-.12.26-.2.41l-.68 1.35 1-.59h.07v.49a.27.27 0 0 1 0 .12s0 .07-.07.08l-1.71 1h-.07a.12.12 0 0 1 0-.09v-.35a.39.39 0 0 1 0-.18.48.48 0 0 1 .06-.14Z",
    style: {
      fill: "#455a64",
      transformOrigin: "261.783px 201.994px"
    },
    id: "elvq4xdg0aihr",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.12 199.44v1a4.32 4.32 0 0 1-.07.64 2.36 2.36 0 0 1-.17.59 1.66 1.66 0 0 1-.3.49 1.68 1.68 0 0 1-.45.38.85.85 0 0 1-.45.14.37.37 0 0 1-.3-.15.79.79 0 0 1-.17-.38 2.49 2.49 0 0 1-.06-.57v-.98a3.49 3.49 0 0 1 .06-.65 2.36 2.36 0 0 1 .17-.59 2.29 2.29 0 0 1 .3-.5 1.52 1.52 0 0 1 .45-.38.88.88 0 0 1 .45-.15.4.4 0 0 1 .3.15.78.78 0 0 1 .17.39 3 3 0 0 1 .07.57Zm-1.48 1.82a1 1 0 0 0 .13.56c.07.11.19.11.36 0a.87.87 0 0 0 .37-.43 2.26 2.26 0 0 0 .12-.7v-.95a1.19 1.19 0 0 0-.12-.56c-.08-.1-.2-.11-.37 0a.84.84 0 0 0-.36.43 2.09 2.09 0 0 0-.13.71v.94Z",
    style: {
      fill: "#455a64",
      transformOrigin: "264.135px 200.505px"
    },
    id: "elg8ob0rjlg",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.51 198.37a.49.49 0 0 1-.25-.91l57.21-33a.5.5 0 0 1 .5.86l-57.22 33a.5.5 0 0 1-.24.05Z",
    style: {
      fill: "#e0e0e0",
      transformOrigin: "298.099px 181.393px"
    },
    id: "el3bajh7fb3t5",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.6 183.6a.06.06 0 0 1 .07 0 .12.12 0 0 1 0 .09v.4a.68.68 0 0 1 0 .14l-.06.12-.53 1.18a.68.68 0 0 1 .3-.05.4.4 0 0 1 .23.1.54.54 0 0 1 .14.26 1.24 1.24 0 0 1 .05.41 2.1 2.1 0 0 1-.07.56 2.28 2.28 0 0 1-.21.51 1.9 1.9 0 0 1-.31.42 1.66 1.66 0 0 1-.4.31 1.12 1.12 0 0 1-.44.17.54.54 0 0 1-.32-.06.46.46 0 0 1-.19-.22 1.16 1.16 0 0 1-.08-.32.28.28 0 0 1 0-.13.19.19 0 0 1 .07-.08l.29-.17h.06a.28.28 0 0 1 .05.08s0 .07.06.09a.16.16 0 0 0 .1.05.27.27 0 0 0 .15 0l.22-.1a1 1 0 0 0 .36-.35.86.86 0 0 0 .14-.47c0-.17-.05-.26-.14-.28a.52.52 0 0 0-.36.1l-.3.17h-.07a.12.12 0 0 1 0-.09V186a.35.35 0 0 1 0-.14.61.61 0 0 1 .05-.12l.51-1.12-1 .58a.06.06 0 0 1-.07 0s0 0 0-.09v-.4a.27.27 0 0 1 0-.12.22.22 0 0 1 .07-.09Z",
    style: {
      fill: "#455a64",
      transformOrigin: "261.787px 185.906px"
    },
    id: "elptcq8756nk",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.16 183.6v1a4.32 4.32 0 0 1-.07.64 2.85 2.85 0 0 1-.16.59 1.93 1.93 0 0 1-.31.49 1.68 1.68 0 0 1-.45.38.85.85 0 0 1-.45.14.37.37 0 0 1-.3-.15.89.89 0 0 1-.17-.38 3.22 3.22 0 0 1-.06-.57v-.98a4.62 4.62 0 0 1 .06-.65 2.87 2.87 0 0 1 .17-.59 2.29 2.29 0 0 1 .3-.5 1.52 1.52 0 0 1 .45-.38.88.88 0 0 1 .45-.15.44.44 0 0 1 .31.15.88.88 0 0 1 .16.39 3 3 0 0 1 .07.57Zm-1.48 1.82a1.14 1.14 0 0 0 .13.56c.07.11.19.11.36 0a.82.82 0 0 0 .37-.43 2.26 2.26 0 0 0 .12-.7v-.95a1.19 1.19 0 0 0-.12-.56c-.07-.1-.2-.11-.37 0a.84.84 0 0 0-.36.43 2.37 2.37 0 0 0-.13.71v.94Z",
    style: {
      fill: "#455a64",
      transformOrigin: "264.175px 184.665px"
    },
    id: "elj620pf3216",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.51 182.56a.49.49 0 0 1-.25-.92l57.21-33a.49.49 0 1 1 .5.85l-57.22 33a.42.42 0 0 1-.24.07Z",
    style: {
      fill: "#e0e0e0",
      transformOrigin: "298.109px 165.566px"
    },
    id: "elmh16wtlkwyc",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.51 229.51v-45s5.7-4 9.85 9.22 12.7 7.92 18.37-1.64 8.22-19.19 14.32-22.71 10.53 8.84 14.67 6.45v20.69Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "298.115px 199.127px"
    },
    id: "elztz8zbxeg3f",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.51 229.51v-45s5.7-4 9.85 9.22 12.7 7.92 18.37-1.64 8.22-19.19 14.32-22.71 10.53 8.84 14.67 6.45v20.69Z",
    style: {
      opacity: 0.2,
      transformOrigin: "298.115px 199.127px"
    },
    className: "animable",
    id: "elfi3rt55gi09"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.51 222.68s3-14.65 5.86-16.29c3.67-2.12 4.15 11.13 10.5 7.47s8-36.3 14.48-40.06 7.53 14.61 12.33 11.84 5.91-13.1 14-17.79v28.63l-57.21 33Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "298.075px 198.665px"
    },
    id: "el8v5v9m6z3ww",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.11 173.12c-3.48 4.85-5 10.56-8.43 12.52-3 1.74-4.55-4.92-6.9-9.13-2.49 4.38-4.73 9.94-8 15.54a27.78 27.78 0 0 1-5.91 7.25c-1.64 7-3.42 13.09-5.95 14.56-6.35 3.66-6.83-9.59-10.49-7.47-2.85 1.64-5.87 16.29-5.87 16.29v6.83l57.21-33v-20.72c-1.83 1.03-3.67-.68-5.66-2.67Z",
    style: {
      opacity: 0.1,
      transformOrigin: "298.165px 201.315px"
    },
    className: "animable",
    id: "el6zndpv9qqvn"
  })), /*#__PURE__*/React.createElement("g", {
    className: "animable",
    style: {
      transformOrigin: "294.845px 283.14px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "m257 270.37 75.69-43.7c1.18-.68 2.13-.13 2.13 1.23v64.32a4.7 4.7 0 0 1-2.13 3.69L257 339.61c-1.18.68-2.13.13-2.13-1.23v-64.32a4.7 4.7 0 0 1 2.13-3.69Z",
    style: {
      fill: "#fafafa",
      transformOrigin: "294.845px 283.14px"
    },
    id: "el0s3c2m1u59p",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#e0e0e0",
      transformOrigin: "265.22px 300.255px"
    },
    id: "elj9r7mp3u9dg",
    className: "animable",
    d: "m267.32 322.52-4.2 2.42v-46.95l4.2-2.42v46.95z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#e0e0e0",
      transformOrigin: "272.63px 295.975px"
    },
    id: "elbg08tcrgrri",
    className: "animable",
    d: "m274.73 318.24-4.2 2.42v-46.95l4.2-2.42v46.95z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#e0e0e0",
      transformOrigin: "280.04px 291.695px"
    },
    id: "el6yitdm5cwkk",
    className: "animable",
    d: "m282.14 313.96-4.2 2.42v-46.94l4.2-2.43v46.95z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#e0e0e0",
      transformOrigin: "287.45px 287.42px"
    },
    id: "elqm4g37qg3oo",
    className: "animable",
    d: "m289.55 309.68-4.2 2.43v-46.95l4.2-2.43v46.95z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#e0e0e0",
      transformOrigin: "294.86px 283.14px"
    },
    id: "elgf1fqf8ftvk",
    className: "animable",
    d: "m296.96 305.4-4.2 2.43v-46.95l4.2-2.43v46.95z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#e0e0e0",
      transformOrigin: "302.275px 278.865px"
    },
    id: "elybera5q2jn",
    className: "animable",
    d: "m304.37 301.12-4.19 2.43V256.6l4.19-2.42v46.94z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b0bec5",
      transformOrigin: "302.275px 266.105px"
    },
    id: "el6igcg0i3xtd",
    className: "animable",
    d: "m300.18 256.6 4.19-2.42v21.42l-4.19 2.43V256.6z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#e0e0e0",
      transformOrigin: "309.69px 274.585px"
    },
    id: "elp4id12vqz99",
    className: "animable",
    d: "m311.79 296.85-4.2 2.42v-46.95l4.2-2.42v46.95z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#e0e0e0",
      transformOrigin: "317.1px 270.305px"
    },
    id: "eltvcuxq5evv9",
    className: "animable",
    d: "m319.2 292.57-4.2 2.42v-46.95l4.2-2.42v46.95z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#e0e0e0",
      transformOrigin: "324.51px 266.025px"
    },
    id: "eleufttfmjj89",
    className: "animable",
    d: "m326.61 288.29-4.2 2.42v-46.95l4.2-2.42v46.95z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b0bec5",
      transformOrigin: "265.22px 300.14px"
    },
    id: "elayp9xnj18br",
    className: "animable",
    d: "m263.12 288.24 4.2-2.42v26.21l-4.2 2.43v-26.22z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.15,
      transformOrigin: "265.22px 318.485px"
    },
    className: "animable",
    d: "m263.12 314.46 4.2-2.43v10.49l-4.2 2.42v-10.48z",
    id: "elb2jcfq7iwx"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b0bec5",
      transformOrigin: "272.63px 293.43px"
    },
    id: "el1agh473c79",
    className: "animable",
    d: "m270.53 289.92 4.2-2.42v9.44l-4.2 2.42v-9.44z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.15,
      transformOrigin: "272.63px 308.8px"
    },
    className: "animable",
    d: "m270.53 299.36 4.2-2.42v21.3l-4.2 2.42v-21.3z",
    id: "elfhpa8pl6s8"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b0bec5",
      transformOrigin: "280.04px 276.27px"
    },
    id: "elrvf4gbuibq",
    className: "animable",
    d: "m277.94 273.37 4.2-2.43v8.24l-4.2 2.42v-8.23z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.15,
      transformOrigin: "280.04px 297.78px"
    },
    className: "animable",
    d: "m277.94 281.6 4.2-2.42v34.78l-4.2 2.42V281.6z",
    id: "elk6g4asx7zeb"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b0bec5",
      transformOrigin: "287.45px 284.565px"
    },
    id: "el81tdiq2kuu8",
    className: "animable",
    d: "m285.35 275.41 4.2-2.43v20.75l-4.2 2.42v-20.74z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.15,
      transformOrigin: "287.45px 302.92px"
    },
    className: "animable",
    d: "m285.35 296.15 4.2-2.42v15.95l-4.2 2.43v-15.96z",
    id: "elayfuczq9m5s"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b0bec5",
      transformOrigin: "294.86px 282.73px"
    },
    id: "elmeoi4r4uduj",
    className: "animable",
    d: "m292.76 279.56 4.2-2.43v8.77l-4.2 2.43v-8.77z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.15,
      transformOrigin: "294.86px 296.865px"
    },
    className: "animable",
    d: "m292.76 288.33 4.2-2.43v19.5l-4.2 2.43v-19.5z",
    id: "elkbb20vtcuos"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.15,
      transformOrigin: "302.275px 289.575px"
    },
    className: "animable",
    d: "m300.18 278.03 4.19-2.43v25.52l-4.19 2.43v-25.52z",
    id: "elhzyr1cidd7q"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b0bec5",
      transformOrigin: "309.69px 281.1px"
    },
    id: "elwidzsp95j4o",
    className: "animable",
    d: "m307.59 277.15 4.2-2.42v10.32l-4.2 2.42v-10.32z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.15,
      transformOrigin: "309.69px 292.16px"
    },
    className: "animable",
    d: "m307.59 287.47 4.2-2.42v11.8l-4.2 2.42v-11.8z",
    id: "elhig7xbvdbn9"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b0bec5",
      transformOrigin: "317.1px 266.545px"
    },
    id: "elcdv1hd61d2t",
    className: "animable",
    d: "m315 256.09 4.2-2.43v23.35l-4.2 2.42v-23.34z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.15,
      transformOrigin: "317.1px 286px"
    },
    className: "animable",
    d: "m315 279.43 4.2-2.42v15.56l-4.2 2.42v-15.56z",
    id: "eluzj0skurb7g"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b0bec5",
      transformOrigin: "324.51px 267.38px"
    },
    id: "eltl2epes3tgd",
    className: "animable",
    d: "m322.41 264.53 4.2-2.42v8.12l-4.2 2.42v-8.12z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b0bec5",
      transformOrigin: "324.51px 280.47px"
    },
    id: "el3ykbek7q97",
    className: "animable",
    d: "m322.41 272.65 4.2-2.42v18.06l-4.2 2.42v-18.06z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b0bec5",
      transformOrigin: "265.22px 318.485px"
    },
    id: "elxchht8gvlap",
    className: "animable",
    d: "m263.12 314.46 4.2-2.43v10.49l-4.2 2.42v-10.48z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.2,
      transformOrigin: "265.22px 318.485px"
    },
    className: "animable",
    d: "m263.12 314.46 4.2-2.43v10.49l-4.2 2.42v-10.48z",
    id: "el5j78jmnb6x4"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b0bec5",
      transformOrigin: "272.63px 308.8px"
    },
    id: "elxyppbm3y8o",
    className: "animable",
    d: "m270.53 299.36 4.2-2.42v21.3l-4.2 2.42v-21.3z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.2,
      transformOrigin: "272.63px 308.8px"
    },
    className: "animable",
    d: "m270.53 299.36 4.2-2.42v21.3l-4.2 2.42v-21.3z",
    id: "el64skxsgbnms"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b0bec5",
      transformOrigin: "280.04px 297.78px"
    },
    id: "eleq2ay661awc",
    className: "animable",
    d: "m277.94 281.6 4.2-2.42v34.78l-4.2 2.42V281.6z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.2,
      transformOrigin: "280.04px 297.78px"
    },
    className: "animable",
    d: "m277.94 281.6 4.2-2.42v34.78l-4.2 2.42V281.6z",
    id: "el8m3ylfmh3vo"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b0bec5",
      transformOrigin: "287.45px 302.92px"
    },
    id: "eloiljbcvqi8",
    className: "animable",
    d: "m285.35 296.15 4.2-2.42v15.95l-4.2 2.43v-15.96z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.2,
      transformOrigin: "287.45px 302.92px"
    },
    className: "animable",
    d: "m285.35 296.15 4.2-2.42v15.95l-4.2 2.43v-15.96z",
    id: "el6gtwvum98nn"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b0bec5",
      transformOrigin: "294.86px 296.865px"
    },
    id: "elb4tb8orcvw",
    className: "animable",
    d: "m292.76 288.33 4.2-2.43v19.5l-4.2 2.43v-19.5z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.2,
      transformOrigin: "294.86px 296.865px"
    },
    className: "animable",
    d: "m292.76 288.33 4.2-2.43v19.5l-4.2 2.43v-19.5z",
    id: "eli5smndc1cdk"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b0bec5",
      transformOrigin: "302.275px 289.575px"
    },
    id: "eln1ubaf85uzo",
    className: "animable",
    d: "m300.18 278.03 4.19-2.43v25.52l-4.19 2.43v-25.52z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.2,
      transformOrigin: "302.275px 289.575px"
    },
    className: "animable",
    d: "m300.18 278.03 4.19-2.43v25.52l-4.19 2.43v-25.52z",
    id: "ele5mc6jkebwi"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b0bec5",
      transformOrigin: "309.69px 292.16px"
    },
    id: "elcbxcev14k6",
    className: "animable",
    d: "m307.59 287.47 4.2-2.42v11.8l-4.2 2.42v-11.8z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.2,
      transformOrigin: "309.69px 292.16px"
    },
    className: "animable",
    d: "m307.59 287.47 4.2-2.42v11.8l-4.2 2.42v-11.8z",
    id: "el62ko450e1t9"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b0bec5",
      transformOrigin: "317.1px 286px"
    },
    id: "elfv6qqagw1lp",
    className: "animable",
    d: "m315 279.43 4.2-2.42v15.56l-4.2 2.42v-15.56z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.2,
      transformOrigin: "317.1px 286px"
    },
    className: "animable",
    d: "m315 279.43 4.2-2.42v15.56l-4.2 2.42v-15.56z",
    id: "ellahjr87lgad"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.2,
      transformOrigin: "324.51px 280.47px"
    },
    className: "animable",
    d: "m322.41 272.65 4.2-2.42v18.06l-4.2 2.42v-18.06z",
    id: "el0wih3o2ew45"
  })), /*#__PURE__*/React.createElement("g", {
    className: "animable",
    style: {
      transformOrigin: "387.7px 173.67px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "m357.7 156.36 60-34.62c1.17-.68 2.13-.13 2.13 1.23v64.32a4.73 4.73 0 0 1-2.13 3.69l-60 34.62c-1.17.68-2.13.13-2.13-1.23v-64.32a4.73 4.73 0 0 1 2.13-3.69Z",
    style: {
      fill: "#fafafa",
      transformOrigin: "387.7px 173.67px"
    },
    id: "el5sq5n8ivg58",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.75 226.39a1.57 1.57 0 0 1-.8-.21 2 2 0 0 1-.88-1.81v-64.32a5.22 5.22 0 0 1 2.38-4.13l60-34.61a1.93 1.93 0 0 1 2-.15 2 2 0 0 1 .88 1.81v64.32a5.2 5.2 0 0 1-2.38 4.12L358 226a2.4 2.4 0 0 1-1.25.39ZM418.62 122a1.41 1.41 0 0 0-.7.22l-60 34.62a4.23 4.23 0 0 0-1.88 3.26v64.32a.82.82 0 0 0 1.38.8l60-34.62a4.23 4.23 0 0 0 1.88-3.26V123a1.05 1.05 0 0 0-.38-1 .56.56 0 0 0-.3 0Z",
    style: {
      fill: "#e0e0e0",
      transformOrigin: "387.7px 173.67px"
    },
    id: "el5dplrdcye3e",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.69 152.55c3.47-2 6.68-2.34 9.29-1.32l-9.29 22.44Z",
    style: {
      fill: "#455a64",
      transformOrigin: "392.335px 162.171px"
    },
    id: "el4qga4z8p69r",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378.39 162a28.88 28.88 0 0 1 9.3-9.42v21.12Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "383.04px 163.14px"
    },
    id: "elwq5mv0qln1p",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.63 175.84a42.14 42.14 0 0 1 5.76-13.84l9.3 11.7Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "380.16px 168.92px"
    },
    id: "elv33tufghec",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M397 151.23c2.68 1.06 4.72 3.54 5.76 7.22l-15.05 15.22Z",
    style: {
      fill: "#455a64",
      transformOrigin: "395.235px 162.45px"
    },
    id: "el3r8mpxs31ve",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.63 188.89a22.37 22.37 0 0 1-.78-6.08 33.53 33.53 0 0 1 .78-7l15.06-2.17Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "379.769px 181.265px"
    },
    id: "elsobrla1wvi",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M402.74 171.5a42.14 42.14 0 0 1-5.74 13.87l-9.29-11.7Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "395.225px 178.435px"
    },
    id: "elc8vaxpn4bh",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.69 194.78c-3.48 2-6.69 2.35-9.3 1.32l9.3-22.43Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "383.04px 185.167px"
    },
    id: "elat2hh4qjp1u",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m372.63 188.89 15.06-15.22-9.3 22.43c-2.68-1.05-4.72-3.54-5.76-7.21Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "380.16px 184.885px"
    },
    id: "elb5wi505pzbr",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378.39 162a42.14 42.14 0 0 0-5.76 13.87 33.53 33.53 0 0 0-.78 7 22.37 22.37 0 0 0 .78 6.08c1 3.67 3.08 6.16 5.76 7.21l9.3-22.43Z",
    style: {
      opacity: 0.1,
      transformOrigin: "379.769px 179.08px"
    },
    className: "animable",
    id: "el2wadgiwud7s"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M402.74 158.45a22.37 22.37 0 0 1 .78 6.08 33.68 33.68 0 0 1-.78 7l-15.05 2.17Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "395.606px 166.075px"
    },
    id: "elmxh17mteqd8",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M397 185.37a28.91 28.91 0 0 1-9.29 9.41v-21.11Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "392.355px 184.225px"
    },
    id: "el2bb9b81jmhv",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m402.74 158.45-15.05 15.22-9.3 22.43c2.61 1 5.82.69 9.3-1.32a28.91 28.91 0 0 0 9.29-9.41 42.14 42.14 0 0 0 5.76-13.87 33.68 33.68 0 0 0 .78-7 22.37 22.37 0 0 0-.78-6.05Z",
    style: {
      opacity: 0.2,
      transformOrigin: "390.955px 177.551px"
    },
    className: "animable",
    id: "el2er9jj4nqz8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.15 201.72a10 10 0 0 1-5.12-1.34c-4.32-2.49-6.8-8.24-6.8-15.76 0-14.1 8.62-30.55 19.21-36.67 4.72-2.72 9.3-3.08 12.9-1 4.32 2.5 6.8 8.25 6.8 15.77 0 14.1-8.62 30.55-19.21 36.66a15.68 15.68 0 0 1-7.78 2.34Zm15.07-55.12a14.75 14.75 0 0 0-7.29 2.21c-10.32 6-18.72 22-18.72 35.81 0 7.16 2.3 12.6 6.31 14.91 3.29 1.9 7.52 1.54 11.92-1 10.32-6 18.72-22 18.72-35.81 0-7.16-2.3-12.6-6.31-14.91a9.07 9.07 0 0 0-4.63-1.21Z",
    style: {
      fill: "#e0e0e0",
      transformOrigin: "387.685px 173.667px"
    },
    id: "ele9zme3s796o",
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubble--inject-4",
    className: "animable",
    style: {
      transformOrigin: "370.84px 117.729px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M353.47 140.92a1.77 1.77 0 0 1-.87-.23 2.13 2.13 0 0 1-.94-2v-20.32a5.74 5.74 0 0 1 2.63-4.56L386.85 95a1.93 1.93 0 0 1 3.15 1.82v20.35a5.75 5.75 0 0 1-2.63 4.56l-4.82 2.78-3.26 11.07a1.12 1.12 0 0 1-1 .82 1.14 1.14 0 0 1-1.12-.69l-2.8-6.46-19.54 11.27a2.67 2.67 0 0 1-1.36.4Zm33.87-45.06-32.56 18.8a4.82 4.82 0 0 0-2.14 3.71v20.35a1 1 0 0 0 1.65.95l20.49-11.83 3.24 7.48a.16.16 0 0 0 .16.1.16.16 0 0 0 .14-.12l3.36-11.44 5.17-3a4.81 4.81 0 0 0 2.14-3.7V96.82a1 1 0 0 0-1.65-1Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "370.84px 117.729px"
    },
    id: "elndnw8y6k479",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.62 120.39a.49.49 0 0 1-.25-.92l22.4-12.93a.49.49 0 1 1 .49.85l-22.4 12.93a.42.42 0 0 1-.24.07Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "370.81px 113.432px"
    },
    id: "ely9n536rh4s",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.62 124.72a.49.49 0 0 1-.25-.91l22.4-12.94a.5.5 0 0 1 .67.18.49.49 0 0 1-.18.68l-22.4 12.93a.5.5 0 0 1-.24.06Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "370.821px 117.764px"
    },
    id: "elw0aagz24bck",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.62 129.06a.51.51 0 0 1-.43-.24.5.5 0 0 1 .18-.68l22.4-12.93a.5.5 0 0 1 .67.18.48.48 0 0 1-.18.67L359.86 129a.5.5 0 0 1-.24.06Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "370.817px 122.104px"
    },
    id: "elq3pyjs990pe",
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    className: "animable",
    style: {
      transformOrigin: "369.33px 253.652px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M346.83 255.91a.5.5 0 0 1-.24-.06.48.48 0 0 1-.25-.43v-9.23a.48.48 0 0 1 .25-.43l8-4.61a.5.5 0 0 1 .74.42v9.24a.48.48 0 0 1-.25.42l-8 4.62a.54.54 0 0 1-.25.06Zm.49-9.44v8.1l7-4v-8.09Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "350.835px 248.499px"
    },
    id: "el99v88u19i1h",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.76 239.26a1 1 0 0 0-1.27.52l-3.66 8.72-.87-.85a1 1 0 0 0-1.36 1.35l1.9 1.84a.94.94 0 0 0 .67.27.68.68 0 0 0 .2 0 1 1 0 0 0 .7-.57l4.21-10a1 1 0 0 0-.52-1.28Z",
    style: {
      fill: "#455a64",
      transformOrigin: "352.416px 245.155px"
    },
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m361.62 240.88 29.42-17c.71-.41 1.28-.12 1.28.65a2.74 2.74 0 0 1-1.28 2.13l-29.42 17c-.7.41-1.28.11-1.28-.65a2.75 2.75 0 0 1 1.28-2.13Z",
    style: {
      fill: "#455a64",
      transformOrigin: "376.33px 233.769px"
    },
    id: "el470rqcc0z04",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.83 269.76a.57.57 0 0 1-.25-.06.5.5 0 0 1-.24-.43V260a.5.5 0 0 1 .24-.43l8-4.61a.48.48 0 0 1 .49 0 .47.47 0 0 1 .25.42v9.23a.48.48 0 0 1-.25.43l-8 4.62a.54.54 0 0 1-.24.1Zm.49-9.44v8.1l7-4.05v-8.1Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "350.83px 262.326px"
    },
    id: "el8vebr0pwoh7",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.76 253.11a1 1 0 0 0-1.27.52l-3.66 8.72-.87-.85a1 1 0 0 0-1.36 1.39l1.9 1.84a1 1 0 0 0 .67.27.68.68 0 0 0 .2 0 1 1 0 0 0 .7-.57l4.21-10a1 1 0 0 0-.52-1.32Z",
    style: {
      fill: "#455a64",
      transformOrigin: "352.406px 259.025px"
    },
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m361.62 254.68 29.42-17c.71-.4 1.28-.11 1.28.66a2.74 2.74 0 0 1-1.28 2.13l-29.42 17c-.7.41-1.28.12-1.28-.65a2.77 2.77 0 0 1 1.28-2.14Z",
    style: {
      fill: "#455a64",
      transformOrigin: "376.33px 247.578px"
    },
    id: "el6kcpak7ter4",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.83 283.61a.49.49 0 0 1-.49-.49v-9.23a.5.5 0 0 1 .24-.43l8-4.61a.48.48 0 0 1 .49 0 .47.47 0 0 1 .25.42v9.23a.48.48 0 0 1-.25.43l-8 4.61a.45.45 0 0 1-.24.07Zm.49-9.44v8.1l7-4v-8.1Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "350.83px 276.196px"
    },
    id: "elgktwvsj0au8",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.76 267a1 1 0 0 0-1.27.51l-3.66 8.72-.87-.84a1 1 0 0 0-1.36 1.39l1.9 1.84a1 1 0 0 0 .67.27h.2a1 1 0 0 0 .7-.57l4.21-10a1 1 0 0 0-.52-1.32Z",
    style: {
      fill: "#455a64",
      transformOrigin: "352.406px 272.911px"
    },
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m361.62 268.49 29.42-17c.71-.41 1.28-.12 1.28.65a2.74 2.74 0 0 1-1.28 2.13l-29.42 17c-.7.41-1.28.11-1.28-.65a2.75 2.75 0 0 1 1.28-2.13Z",
    style: {
      fill: "#455a64",
      transformOrigin: "376.33px 261.379px"
    },
    id: "ele8kxi48kom",
    className: "animable"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubbles--inject-4",
    className: "animable",
    style: {
      transformOrigin: "129.657px 93.886px"
    }
  }, /*#__PURE__*/React.createElement("g", {
    className: "animable",
    style: {
      transformOrigin: "179.458px 80.1603px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M177.58 105.55a1.92 1.92 0 0 1-.91-.23 2.27 2.27 0 0 1-1-2.09V81.44a6.12 6.12 0 0 1 2.8-4.85l34.86-20.13a2 2 0 0 1 3.3 1.9v21.79a6.12 6.12 0 0 1-2.8 4.86l-5.18 3-3.49 11.86a1.19 1.19 0 0 1-2.23.14l-3-7L179 105.14a2.86 2.86 0 0 1-1.42.41Zm36.26-48.24L179 77.44a5.2 5.2 0 0 0-2.31 4v21.79a1.36 1.36 0 0 0 .51 1.23 1.33 1.33 0 0 0 1.31-.18l21.91-12.64 3.45 8a.19.19 0 0 0 .2.12.19.19 0 0 0 .19-.14l3.59-12.25 5.52-3.18a5.19 5.19 0 0 0 2.31-4V58.36a1.08 1.08 0 0 0-1.81-1Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "196.168px 80.7454px"
    },
    id: "elue8m8jozf4o",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.17 83.57a.51.51 0 0 1-.43-.24.49.49 0 0 1 .18-.68l24-13.85a.5.5 0 0 1 .5.86l-24 13.85a.53.53 0 0 1-.25.06Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "196.148px 76.1628px"
    },
    id: "el8wdp7ljpa9x",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.17 88.21a.49.49 0 0 1-.43-.24.48.48 0 0 1 .18-.67l24-13.85a.49.49 0 0 1 .68.18.5.5 0 0 1-.18.67l-24 13.85a.53.53 0 0 1-.25.06Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "196.166px 80.7949px"
    },
    id: "elxocjxidnnqc",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.17 92.86a.5.5 0 0 1-.43-.25.48.48 0 0 1 .18-.67l24-13.85a.5.5 0 1 1 .5.86l-24 13.84a.44.44 0 0 1-.25.07Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "196.192px 85.4273px"
    },
    id: "elviyznp2v5q",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.16 104.38a1.82 1.82 0 0 1-.91-.24 2.26 2.26 0 0 1-1-2.08V80.27a6.1 6.1 0 0 1 2.8-4.85l34.86-20.13a2 2 0 0 1 3.3 1.9V71a.5.5 0 0 1-.5.49.49.49 0 0 1-.49-.49V57.19a1.36 1.36 0 0 0-.5-1.23 1.38 1.38 0 0 0-1.32.18l-34.85 20.13a5.18 5.18 0 0 0-2.31 4v21.79a1.08 1.08 0 0 0 1.82 1l27.39-15.76a.49.49 0 0 1 .68.18.5.5 0 0 1-.18.67L145.55 104a2.78 2.78 0 0 1-1.39.38Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "162.748px 79.5754px"
    },
    id: "el4vit79y1voc",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.74 82.4a.49.49 0 0 1-.24-.92l24-13.85a.51.51 0 0 1 .68.18.5.5 0 0 1-.18.67l-24 13.85a.45.45 0 0 1-.26.07Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "162.744px 74.9837px"
    },
    id: "el6dujyp8g2nv",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.74 87a.49.49 0 0 1-.24-.92l24-13.84a.49.49 0 0 1 .68.18.5.5 0 0 1-.18.67L151 87a.54.54 0 0 1-.26 0Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "162.744px 79.5928px"
    },
    id: "ely5rmzfimeh",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.74 91.69a.49.49 0 0 1-.24-.92l21.43-12.4a.48.48 0 0 1 .67.18.5.5 0 0 1-.18.67L151 91.62a.45.45 0 0 1-.26.07Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "161.454px 84.9954px"
    },
    id: "el2nkaukajrct",
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    className: "animable",
    style: {
      transformOrigin: "61.22px 112.063px"
    }
  }, /*#__PURE__*/React.createElement("g", {
    className: "animable",
    style: {
      transformOrigin: "61.22px 112.063px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "m64.33 130.09-2.43-4.57 2-5.64v-3.46l-6 3.46v3.45l2.57 4.45a.39.39 0 0 0 .18.16Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "61.115px 123.255px"
    },
    id: "elf6kynwupzj",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m64.33 130.09-2.43-4.57 2-5.64v-3.46l-6 3.46v3.45l2.57 4.45a.39.39 0 0 0 .18.16Z",
    style: {
      opacity: 0.2,
      transformOrigin: "61.115px 123.255px"
    },
    className: "animable",
    id: "el7zpvf1nu9d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.8 95.5a4 4 0 0 0-1.8-3.11l-1.46-.84a4 4 0 0 0-3.59 0L44.43 108a4 4 0 0 0-1.79 3.11v17.49a4 4 0 0 0 1.79 3.11l1.46.84a4 4 0 0 0 3.59 0l12.15-7.07 2.56 4.52a.39.39 0 0 0 .7-.07l2.71-7.83 10.41-6a4 4 0 0 0 1.79-3.1Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "61.22px 112.05px"
    },
    id: "eljt0t7xhpvkb",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.64 128.62a4 4 0 0 0 1.79 3.11l1.46.84a4 4 0 0 0 3.28.15c-.84.32-1.49-.16-1.49-1.18V114a3.59 3.59 0 0 1 .53-1.76l-5.05-2.92a3.75 3.75 0 0 0-.52 1.77Z",
    style: {
      opacity: 0.2,
      transformOrigin: "45.905px 121.161px"
    },
    className: "animable",
    id: "elb08kdylh3s"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.74 95c-.21-.76-.9-1-1.73-.53l-28.53 16.47a3.5 3.5 0 0 0-1.27 1.34l-5-2.91a3.55 3.55 0 0 1 1.22-1.37L73 91.55a4 4 0 0 1 3.59 0l1.41.85a3.9 3.9 0 0 1 1.74 2.6Z",
    style: {
      fill: "#fff",
      opacity: 0.4,
      transformOrigin: "61.475px 101.702px"
    },
    className: "animable",
    id: "eljsytmixdhq"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M55 115.82a5.3 5.3 0 0 0-2.42 4.18c0 1.53 1.07 2.14 2.39 1.38a5.29 5.29 0 0 0 2.39-4.14c0-1.56-1.07-2.18-2.36-1.42Z",
    style: {
      fill: "#fff",
      transformOrigin: "54.97px 118.601px"
    },
    id: "el4xzsr7jzmmf",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.8 110.72a5.27 5.27 0 0 0-2.4 4.14c0 1.53 1.07 2.15 2.4 1.39a5.3 5.3 0 0 0 2.39-4.15c0-1.53-1.07-2.1-2.39-1.38Z",
    style: {
      fill: "#fff",
      transformOrigin: "63.795px 113.493px"
    },
    id: "el88mniaj7ymd",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.62 105.61a5.3 5.3 0 0 0-2.39 4.15c0 1.53 1.07 2.14 2.39 1.38A5.29 5.29 0 0 0 75 107c0-1.53-1.06-2.15-2.38-1.39Z",
    style: {
      fill: "#fff",
      transformOrigin: "72.615px 108.376px"
    },
    id: "elilu31hf48wh",
    className: "animable"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-1--inject-4",
    className: "animable",
    style: {
      transformOrigin: "415.565px 273.953px",
      animation: "1s 1 forwards cubic-bezier(.36,-.01,.5,1.38) slideRight",
      animationDelay: "0s"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--character--inject-4",
    className: "animable",
    style: {
      transformOrigin: "415.565px 273.953px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ffa8a7",
      transformOrigin: "427.365px 196.835px"
    },
    id: "elvbtvgetqi0s",
    className: "animable",
    d: "m421.18 191.62 1.2 12.49 11.17-.69-.89-13.86-11.48 2.06z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435.38 197.15c6.08-1.29 8.76 2.35 11.43 8.86s9.51 20.86 10.62 25.21c.5 1.95-15.79 21.43-15.26 21.17.16-.08-4.82-8.41-4.82-8.41l9.07-12.76L440 221Z",
    style: {
      fill: "#ffa8a7",
      transformOrigin: "446.411px 224.642px"
    },
    id: "elfmiehaktv1o",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M464 343.53c-1.25-3.85-5.95-18.55-7.58-22.74-2.58-6.64-4.24-10.16-9.66-13.56 0 0 .29-33.18 0-45-.37-15.12-3.71-20.19-3.71-20.19l-35 2s-3 25.77-3.56 37.64c-.67 13.37-.67 17.57-.34 24.86.21 4.58.86 8.76 1.21 15.72S407.8 364 407.8 364l.05-.08A9 9 0 0 0 408 365c.32 1.25 1.67 2.67 4.14 2.72 3.51.07 4.62-1.68 4.81-2.81 0-.19.07-.41.1-.64h.06s2.6-14.83 4.32-26.14a106.61 106.61 0 0 0 1.45-15.78 58.75 58.75 0 0 0-1.53-9.66l5-32.51s4.29 27.68 5 30.33c.48 1.85 11.9 19.51 18.77 30 3 4.57 9.75 14.56 10.18 15.12 1.49 2 6.48-5.17 6.48-5.17Z",
    style: {
      fill: "#ffa8a7",
      transformOrigin: "435.357px 304.881px"
    },
    id: "elpm851t7bh0r",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M457.71 351.85c3.61 4.92 5.56 17.95 4.51 19.88s4.18 0 4.9-2.92.85-17.19.85-17.19Z",
    style: {
      fill: "#ffa8a7",
      transformOrigin: "462.84px 362.063px"
    },
    id: "el0w8c36gkn11p",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.74 363.41c-.08 3.81-2.65 13.7-6.37 14.87s1.67 3.89 4.49 2.83 7.09-9.5 9.28-11.59 2.32-7.4 2.32-7.4Z",
    style: {
      fill: "#ffa8a7",
      transformOrigin: "408.782px 371.735px"
    },
    id: "elk09vozp0qyj",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.76 239.9s-1.22 3.85-2.39 18-3.49 34.18-3.65 42.19c0 0 6.18-1.55 8.8-7.2 0 0 4.36 9.43 14.55 11.5s20.42-.69 22.44-6.76c-.06-.66.26-32.59 0-40s-3.1-13.67-5.91-19.93Z",
    style: {
      fill: "#37474f",
      transformOrigin: "424.667px 271.386px"
    },
    id: "elwg8zr0o091",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.86 384.81s.84 1.48 5.39-.43 5.84-4.19 5.84-4.19-1.18-9.15-4-6.85-7.23 11.47-7.23 11.47Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "411.475px 379.163px"
    },
    id: "el7s974rht6av",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.86 384.81s.84 1.48 5.39-.43 5.84-4.19 5.84-4.19-1.18-9.15-4-6.85-7.23 11.47-7.23 11.47Z",
    style: {
      opacity: 0.3,
      transformOrigin: "411.475px 379.163px"
    },
    className: "animable",
    id: "elqnfawiqejqa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M418.15 362.24c-.93-.49-3.41.53-4.86 1.79-1.92 1.65-2.38 3.88-3.36 6.5-1.05 2.8-2.95 6.64-4.48 7.5s-4.34.06-6.66.05-4.11 1.05-4.24 2.74c-.06 1.33 6 4.38 9.76 4.54 3.16.13 4.23.67 6-3.95s2.41-7.22 3.79-4.08S416 387 416 387a2 2 0 0 0 2.79.07 61.27 61.27 0 0 1 .4-6.89c.4-2.84 1.91-7.3 1.72-10.72s-1.84-6.76-2.76-7.22Z",
    style: {
      fill: "#263238",
      transformOrigin: "407.738px 374.859px"
    },
    id: "el8i0unzdwd3",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M468.75 374.21s1.45.71 4.24-3.37a8 8 0 0 0 1.45-2.7 21.36 21.36 0 0 1-.62-5.62c.23-2.88-4.85-3.86-5.46-1.87-1.06 3.48.39 13.56.39 13.56Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "471.206px 366.931px"
    },
    id: "eljj32q8a8g3m",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M468.75 374.21s1.45.71 4.24-3.37a8 8 0 0 0 1.45-2.7 21.36 21.36 0 0 1-.62-5.62c.23-2.88-4.85-3.86-5.46-1.87-1.06 3.48.39 13.56.39 13.56Z",
    style: {
      opacity: 0.3,
      transformOrigin: "471.206px 366.931px"
    },
    className: "animable",
    id: "eluoso73luam"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M466.39 348.61c-1.05.11-2.53 2.34-3.05 4.19-.67 2.44.19 4.55.83 7.27.69 2.91 1.26 7.16.46 8.73s-3.57 2.47-5.5 3.75-2.83 3.16-2 4.63c.69 1.14 7.39.33 10.63-1.66 2.7-1.65 3.89-1.8 2.77-6.61s-2-7.34.88-5.5 7 7 7 7a2 2 0 0 0 2.35-1.51 60.19 60.19 0 0 1-3.5-5.94c-1.25-2.58-2.48-7.13-4.55-9.86s-5.3-4.62-6.32-4.49Z",
    style: {
      fill: "#263238",
      transformOrigin: "468.79px 363.152px"
    },
    id: "elk7brj1blr9",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M442.29 202.58a8.2 8.2 0 0 0-7.63-5.91s-6.72-.22-11.14.17a35.56 35.56 0 0 0-9.38 1.84l-3.84 3.7c-1.77 2.22-4.93 12.19-4.86 29.33 0 3.29-.41 7.32 2.32 8.19 6.41 3.56 22.26 5.15 34.22-1.65 1.74-1.3 1.47-11.41 1.41-16-.09-6.14-.31-17.32-1.1-19.67Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "424.43px 219.784px"
    },
    id: "elu1ejf2qsfb9",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m411.31 216 .3-3.73-.53-.05-.3 3.74c-1 12.86-1.66 21.58-.87 25l.59.23c-.95-3.19-.09-13.92.81-25.19Z",
    style: {
      opacity: 0.15,
      transformOrigin: "410.585px 226.705px"
    },
    className: "animable",
    id: "elg83xfvsvfkm"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414.14 198.68s-2.61 0-10.7 4.41c-5.35 2.93-16.11 8.45-20.58 10.54-3.36-2.81-16.69-14-17.22-15.06-.6-1.25.41-3.22.93-4.32s1.56-3.56 2-4.21c.76-1.15-1.18-1.27-2.57-.37s-2.45 3.07-3.1 3.33-3.6-5.56-5-8.37-2-4.66-3.57-4c-1.15.45-.86 2 .09 4.31a25.87 25.87 0 0 1 1.21 3.08c.09.4-.52.55-.77.69-.48.25-1.32.65-1.51 1.19a4.51 4.51 0 0 1-.28.88c-.35.61-1.24.71-1.63 1.3-.28.42-.23 1-.45 1.46-.13.29-.38.53-.51.83a2.24 2.24 0 0 0 .22 1.86c1 2 2.77 3.17 4.37 4.66 1.34 1.24 2.84 2 4.42 3.25s18.4 21.55 22.18 22.28a6.51 6.51 0 0 0 3.52-.34c3.36-1 17.44-6.7 24.41-9.15 5.35-2.75 7-3.79 8.14-11.72.5-3.89-3.6-6.53-3.6-6.53Z",
    style: {
      fill: "#ffa8a7",
      transformOrigin: "384.076px 203.51px"
    },
    id: "elrhv9lj9lsr",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.34 168.3a2.7 2.7 0 0 1 .33-1.37 1.56 1.56 0 0 1 1.87-.75 6.14 6.14 0 0 1-.82-2.11 2 2 0 0 1 .83-2 3.2 3.2 0 0 1 1.77-.25c3.73.12 7.4-.86 11.11-1.31s7.72-.3 10.81 1.81a8.67 8.67 0 0 1 3.47 4.36 5.38 5.38 0 0 1 .35 2.54 7.1 7.1 0 0 0-.39 2.54 31.75 31.75 0 0 1 .42 4.46c.24 6.17-14.08 10.18-13.8 14.41l-7.63-9.29c0-.39-1.08-1.35-1.32-1.68-.46-.61-.87-1.26-1.29-1.9-1.88-2.87-5.1-5.11-5.64-8.69a5 5 0 0 1-.07-.77Z",
    style: {
      fill: "#263238",
      transformOrigin: "426.216px 175.466px"
    },
    id: "el2vwit1u1odf",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.9 177.9s-2.48 3.68-2.15 4.07a5.88 5.88 0 0 0 1.89.8Z",
    style: {
      fill: "#f28f8f",
      transformOrigin: "411.81px 180.335px"
    },
    id: "elak955ee72e",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M420.46 166.26c-2.41 1.22-6.56 3.48-7.63 12.18-1.1 8.94.92 12 2.16 13.21.84.79 5.16 1.08 7.41.39 2.82-.86 8.92-3.82 11.78-8.43 3.37-5.43 4.07-12.66.18-15.5-5.47-3.99-11.87-2.88-13.9-1.85Z",
    style: {
      fill: "#ffa8a7",
      transformOrigin: "424.758px 178.86px"
    },
    id: "eldj452v583va",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M415.23 191.81c1 .56 3.88.79 6 .48l-.07-1.61a15.11 15.11 0 0 1-2.85.93 9.94 9.94 0 0 1-3.08.2Z",
    style: {
      fill: "#f28f8f",
      transformOrigin: "418.23px 191.554px"
    },
    id: "elqt88malj8gg",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M448.71 164.38a6.74 6.74 0 0 0-9.07-2.94c-2 1-2.2 2.4-1.64 4.07a11.1 11.1 0 0 0-2-1.07 9.49 9.49 0 0 0-1-.3 20.83 20.83 0 0 0-9.74-.21 21.2 21.2 0 0 0-4.65 1.56l-1.14.51a9.3 9.3 0 0 0-2.8 1.61 3.83 3.83 0 0 0-1 1.27 3.06 3.06 0 0 0-.2 1.44 3.85 3.85 0 0 0 2.25 3.1 3.75 3.75 0 0 0-.61 3.11 7.49 7.49 0 0 0 2.21 3.18.46.46 0 0 0 .18.13.5.5 0 0 0 .4-.12c1.51-1 2.44-2.75 4.57-2.05 2.8.92 2.77 5.51.35 7.14a2.19 2.19 0 0 1-2.38.08s.75 6.94-1 8.82c-1.9 2.07-5.26 1.34-5.26 1.34s1.57 7.63 13 6.48c9.66-1 10.17-7 10.17-7a6.78 6.78 0 0 1-2.32 6.05s7.22.68 9.42-4.81c1.65-4.11-2.06-6.87-3-12.08-.38-2.12.51-6.32.35-9.73a3.71 3.71 0 0 0 2-.5 6.73 6.73 0 0 0 2.91-9.08Z",
    style: {
      fill: "#263238",
      transformOrigin: "432.458px 181.175px"
    },
    id: "el5sz99j1z624",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M419.08 182.86a2.06 2.06 0 0 1-1.27-2.66 2.13 2.13 0 0 1 2.71-1.25Z",
    style: {
      fill: "#263238",
      transformOrigin: "419.102px 180.843px"
    },
    id: "elg6v3yuch9v",
    className: "animable"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "active",
    height: "200%"
  }, /*#__PURE__*/React.createElement("feMorphology", {
    in: "SourceAlpha",
    result: "DILATED",
    operator: "dilate",
    radius: 2
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#32DFEC",
    floodOpacity: 1,
    result: "PINK"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "PINK",
    in2: "DILATED",
    operator: "in",
    result: "OUTLINE"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "OUTLINE"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  }))), /*#__PURE__*/React.createElement("filter", {
    id: "hover",
    height: "200%"
  }, /*#__PURE__*/React.createElement("feMorphology", {
    in: "SourceAlpha",
    result: "DILATED",
    operator: "dilate",
    radius: 2
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "red",
    floodOpacity: 0.5,
    result: "PINK"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "PINK",
    in2: "DILATED",
    operator: "in",
    result: "OUTLINE"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "OUTLINE"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 1 0 0 0 0 0 0 0 0 0 0 0 1 0"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoGraphInDashboard);
export default __webpack_public_path__ + "static/media/noGraphInDashboard.27f94448c9951dffaf47850f421e0edd.svg";
export { ForwardRef as ReactComponent };